<template>
  <div ref="ElementoGrafico" style="overflow:clip" :style="GetPositionStyle()">
    <VUEPopupGraficaCatena v-if="PopupImpostazioniGrafiche"
                           :AltezzaPopup="AltezzaPopup + 'px'"
                           :ObjGraficaCatena="ObjGraficoModifica"
                           @OnClickConfermaPopup="ConfermaPopupImpostazioniGrafiche()"
                           @OnClickChiudiPopup="AnnullaPopupImpostazioniGrafiche()"
                           style="pointer-events: all;" />
    
    <VUEConfirm :Popup="PopupAdattamento"
                 style="pointer-events: all;"
                :Richiesta="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_POPUP_ADATT',this.LinguaUtente)"
                :PathLogo="require('@/assets/images/LogoDMS.png')" 
                :Programma="'DMSEW'"
                @onClickChiudiPopup="PopupAdattamento = false" 
                @onClickConfermaPopup="AdattaDimensioniAltriGrafici(); PopupAdattamento = false" />

    <div v-if="MostraGrafici && !Ingrandito" style="height: 20px; width: 20px; background-color: grey; position: absolute; top: 3px; right: 3px; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="OnClickMostraGrafici">
      <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
    </div>
    <div v-if="MenuImpostazioni && MostraGrafici && OnDashboard" style="width: 20px; position: absolute; top: 30px; right: 3px; pointer-events: all">
      <div v-if="Admin" class="ZMGraficoGenericoBottoni"  @click="ApriPopupImpostazioniGrafiche()">
        <a class="fa fa-paint-brush" :title="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MOD_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div v-if="Admin" class="ZMGraficoGenericoBottoni"  @click="PopupAdattamento = true">
        <a class="fa fa-arrows-alt" :title="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_ADATTA_ALTRI_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni"  @click="VaiAGraficiVerticali()">
        <a class="fa fa-chevron-right" :title="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_VAI_GRAF_VERT',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
    <div v-if="MenuImpostazioni && MostraGrafici && !OnDashboard" style="width: 20px; position: absolute; top: 30px; right: 3px; pointer-events: all">
      <div v-if="!IsOrizzontale" class="ZMGraficoGenericoBottoni" @click="ApriDettaglioGrafico()">
        <a class="fa fa-search" :title="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DETTAGLIO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div v-if="this.TipoGrafico == TipiGrafici.ProfiloLong || this.TipoGrafico == TipiGrafici.ProfiloLongAll" class="ZMGraficoGenericoBottoni" @click="CambiaTipologiaCumulazione()">
        <a class="fa fa-line-chart" :title="LabelCumulativo" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ModificaImpostazioniAssi()">
        <a class="fa fa-paint-brush" :title="this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_IMP_ASSI',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ApriStampaPopupPDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>

      <div v-if="TipoGrafico == TipiGrafici.Piezometro" class="ZMGraficoGenericoBottoni" @click="OnClickHiddenPiezometri()">
        <a v-if="!HiddenPiezometri" class="fa fa-check-square-o" title="Nascondi dati" style="color: white; font-size: 14px;"></a>
        <a v-if="HiddenPiezometri"  class="fa fa-square-o" title="Mostra dati" style="color: white; font-size: 14px;"></a>
      </div>
      <!-- <div class="ZMGraficoGenericoBottoni" @click="DaFare()">
        <a class="fa fa-image" title="Esporta come immagine" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="DaFare()">
        <a class="fa fa-clipboard" title="Copia" style="color: white; font-size: 14px;"></a>
      </div> -->
      <div v-if="TipoGrafico == TipiGrafici.SpostAzimuth" class="ZMGraficoGenericoBottoni" @click="ModificaFiltroAzimuth()">
        <a class="fa fa-filter" :title="this.GetTraduzioneLabel('Generic','TKN_FILTRO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>

      <div v-if="TipoGrafico == TipiGrafici.SpostTot" class="ZMGraficoGenericoBottoni" @click="ModificaDirezioneGrafico()">
        <a class="fa fa-exchange" :title="(DirezioneGraficoTotale !== null && DirezioneGraficoTotale !== '') ? this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_VISUALIZZA_SPOSTAMENTO_TOT',this.LinguaUtente) : this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_VISUALIZZA_SPOSTAMENTO_DIR',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
    <!-- COMMENTATO PERCHÉ MAGARI POI CI RIPENSANO SUL VOLERLO AL CENTRO DEL GRAFICO -->
    <!-- <div v-if="CatenaInfo.TipiAllarmiAttivi.length != 0 && OnDashboard" style="position: absolute; cursor: pointer" :style="{'top': GraphCenterCoords.y - (ObjGrafico.PlaceholderDim * (4/3)) + 'px', 'left': GraphCenterCoords.x - ObjGrafico.PlaceholderDim + 'px', 'pointer-events' : Admin ? 'none' : 'all'}" @click="MostraAllarmi = !MostraAllarmi">
      <img v-if="MostraIconaAllarme && MostraGrafici" :src="IconaAllarme" :width="ObjGrafico.PlaceholderDim * 2" :height="ObjGrafico.PlaceholderDim * 2">
    </div> -->
    <div v-if="MostraAllarmi && MostraGrafici" style="position: absolute;" :style="{'top': GraphCenterCoords.y + 'px', 'left': GraphCenterCoords.x + 'px'}">
      <div style="height: 100px; overflow: auto; pointer-events: all" :style="{'background-color': Marrone}">
        <div style="float: right;height: 15px; width: 15px; background-color: grey; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MostraAllarmi = false">
          <a class="fa fa-times" :title="this.GetTraduzioneLabel('Generic','TKN_CHIUDI',this.LinguaUtente)" style="color: white; font-size: 9px;"></a>
        </div>
        <div v-for="Allarme in CatenaInfo.TipiAllarmiAttivi" :key="Allarme" style="background-color: #faf7c3; display: flex; flex-flow: row wrap; align-content: center; width: 150px">
          <div style="display: flex; flex-flow: row wrap; align-content: center; justify-content: center;width: 100%" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">{{Allarme.TIPO + ' ' + Allarme.LIVELLO}}</div>
          <div v-for="Modulo in Allarme.ListaModuli" :key="Modulo" style="display: flex; flex-flow: column wrap; align-content: flex-start; justify-content: flex-start">
              <label style="width: 100%">{{this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MOD',this.LinguaUtente) + Modulo.MODULO + ' (' + Modulo.VALORE + ')'}}</label>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="TipoGrafico === TipiGrafici.Piezometro">
      <div v-if="(!Admin || !OnDashboard) && SelectedMarkup != null && MostraGrafici">
        <div style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 120px; pointer-events: none;" :style="SelectedMarkup[0].Hint.Inverted ? {'top' : GetCoordsTopDataLabel(SelectedMarkup[0].Coords.Y) + 'px', 'right' : GetCoordsTopDataLabel(SelectedMarkup[0].Coords.X) + 'px', 'position' : 'fixed'} : {'top' : GetCoordsTopDataLabel(SelectedMarkup[0].Coords.Y) + 'px', 'left' : GetCoordsLeftDataLabel(SelectedMarkup[0].Coords.X) + 'px', 'position' : 'fixed'}">
          <div v-for="Markup in SelectedMarkup" :key="Markup.Hint.Modulo">
            <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold;  min-width: 120px; padding-left: 3px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
              {{Markup.Hint.PrettyDate}}
            </div>
            <div style="width: 100%; padding-left: 3px; padding-right: 3px;">{{this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + ' ' + Markup.Hint.Modulo}}</div>
            <div v-if="TipoGrafico != TipiGrafici.Deformazione && !Markup.Hint.DontShowX" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center;">
              
              <div style="width: 100%; display: flex; flex-flow: row wrap; padding-left: 3px; padding-right: 3px;">{{ GetXValueForLabel(Markup) }}</div>
              <div style="width: 100%; display: flex; flex-flow: row wrap; padding-left: 3px; padding-right: 3px;">{{ GetYValueForLabel(Markup) }}</div>
  
            </div>
            <div v-else>
              <div style="width: 100%">{{ GetYValueForLabel() }}</div>
              <div style="width: 100%" v-if="!Markup.Hint.DontShowX"> {{ GetXValueForLabel(Markup) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="TipoGrafico !== TipiGrafici.Piezometro">
      <!-- <div v-if="(!Admin || !OnDashboard) && SelectedMarkup != null && MostraGrafici" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none;" :style="SelectedMarkup.Hint.Inverted ? {'top' : SelectedMarkup.Coords.Y + 'px', 'right' : SelectedMarkup.Coords.X + 'px', 'position' : 'absolute'} : {'top' : SelectedMarkup.Coords.Y + 'px', 'left' : SelectedMarkup.Coords.X + 'px', 'position' : 'absolute'}"> -->
      <div v-if="(!Admin || !OnDashboard) && SelectedMarkup != null && MostraGrafici" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none;" :style="SelectedMarkup.Hint.Inverted ? {'top' : GetCoordsTopDataLabel(SelectedMarkup.Coords.Y) + 'px', 'right' : GetCoordsLeftDataLabel(SelectedMarkup.Coords.X) + 'px', 'position' : 'fixed'} : {'top' : GetCoordsTopDataLabel(SelectedMarkup.Coords.Y) + 'px', 'left' : GetCoordsLeftDataLabel((SelectedMarkup.Coords.X < ($refs.Canvas.width / 2)) ? SelectedMarkup.Coords.X : (SelectedMarkup.Coords.X - 150)) + 'px', 'position' : 'fixed'}">
        <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 3px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
          {{SelectedMarkup.Hint.PrettyDate}}
        </div>
        <div style="width: 100%; padding-left: 3px; padding-right: 3px">{{this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + ' ' + SelectedMarkup.Hint.Modulo}}</div>
        <div v-if="TipoGrafico != TipiGrafici.Deformazione && !SelectedMarkup.Hint.DontShowX" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center; padding-left: 3px; padding-right: 3px">
          
          <div style="width: 100%; display: flex; flex-flow: row wrap;">{{ GetXValueForLabel() }}</div>
          <div style="width: 100%; display: flex; flex-flow: row wrap;">{{ GetYValueForLabel() }}</div>

        </div>
        <div v-else>

          <div style="width: 100%">{{ GetYValueForLabel() }}</div>
          <div style="width: 100%" v-if="!SelectedMarkup.Hint.DontShowX"> {{ GetXValueForLabel() }}</div>

        </div>
      </div>
    </div>

    <div v-if="OnDashboard && MostraGrafici" style="position: absolute;" :style="CalculateTitleStyle()">{{InfoCatena.DatiCatena.DESCRIZIONE}}</div>
    <canvas v-show="MostraGrafici" ref="Canvas" @mousedown="OnMouseDown" @mouseup="OnMouseUp" @mouseout="OnMouseLeave" @wheel="OnMouseScroll" @mouseenter="OnMouseEnter"></canvas>
    <div v-if="MostraGrafici && OnDashboard && Admin" style="height: 10px; width: 10px; background-color: yellow; position: absolute; bottom: 0px; right: 0px;"></div>
  </div>      
</template>
<script>

import ObjIconaAllarme from '@/assets/IconaAllarme.json'
import { COLORI_ALLARME, GRANDEZZE_ALLARME, RUOLI, SFONDO, SystemInformation, TIPI_ALLARME, TIPI_GRAFICI, GRAFICI_ATTUALI_TERZO_ASSE, TIPO_ELEMENTO_PDF, TIPOLOGIA_GRAFICI_STORICI, LOCALSTORAGE, TInfoGraficiStorici, COLORE_GRAFICI_VERTICALI  } from '@/SystemInformation.js'
import { saveAs } from 'file-saver'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js'
import VUEConfirm from '@/utils/VUEConfirm.vue'
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { TZGraphLine, TZGraphMarkup, TZGraphNotchType, TZGraphLabelType } from '@/utils/ZGraph.js'
import { TZMathFunct } from '@/utils/ZMathFunct.js'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica.js'
import { TZStringConvFunct } from '@/utils/ZStringConvFunct'
import { TGraficoAttuale } from '../../GraficoAttuale.js'
import VUEPopupGraficaCatena from '../Popups/VUEPopupGraficaCatena.vue'
import { TZGraphPacker, TZGraphPiezometria } from '../SpecialGraphs/GraphPiezometria.js'

export default 
{
  components: { VUEPopupGraficaCatena, VUEConfirm },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              Admin                     : false,
              DragMode                  : false,
              ObjGrafico                : null,
              ObjGraficoModifica        : null,
              MenuImpostazioni          : false,
              PopupImpostazioniGrafiche : false,
              ObjGraficoPolare          : false,
              GraficoCompilato          : null,
              SelectedMarkup            : null,
              LinguaUtente              : SystemInformation.UserInformation.Lingua,
              TickIntervallo            : SystemInformation.Configurazione.TICK_INTERVAL,
              GraphCenterCoords         : { x: 0, y: 0 },
              MostraAllarmi             : false,
              Marrone                   : SFONDO.Marrone,
              GrandezzeAllarme          : GRANDEZZE_ALLARME,
              TipiAllarme               : TIPI_ALLARME,
              MostraIconaAllarme        : false,
              IconaAllarme              : null,
              PopupAdattamento          : false,
              LabelGiaPresente          : false,
              HiddenPiezometri          : false,
              PopupModificaAssi         : false,
              URLSchedaVerticali        : '/appMainWindow/GraficiVerticaliModulabili?',
              TipiGrafici               : TIPI_GRAFICI,
              GraphicDetails            : {
                                            xAngolo   : 0,
                                            yAngolo   : 0,
                                            xStart    : 0,
                                            yStart    : 0,
                                            Zoom      : 1,
                                            dx        : 0,
                                            dy        : 0
                                          },
              UdmLabelX                 : '',
              UdmLabelY                 : '',
              HiddenData                : false
    };
  },
  emits: ["AdattaAltriGrafici", "ApriDettaglio", "ApriPopupFiltroAzimuth", "NascondiIconaAllarme", "ApriPopupModificaDirezioneGrafico", "ApriPopupPDF", "CambiaTipoCumulazione"],
  props: ['Repaint', "CatenaInfo", "AltezzaPopup", "Contatore", "MostraGrafici", "AllineamentoSelezionato", "GraficiChange", "Zoom", "OnDashboard",
          "TipoGrafico", "LarghezzaGrafico", "AltezzaGrafico", "ObjModificaAssi", "Differenziale", "GraficiAdatta", "AllineaTemperatura",
          "Ingrandito", "AddDatiPDF", "ObjEsportazione", 'ModificaGraficiAll', "StatoAbbinati", "UltimaData", "DirezioneGraficoTotaleIngrandito", 
          "StatoAbbinatiPiezometri", "LabelCumulativo", "ParentData", "FiltroAzimuthIngrandito", "AssiModificatiIngranditi"],

  methods:
  {
    DaFare()
    {
      console.error('Da fare')
    },

    CumulativoEDifferenzialePresenti()
    {
      let Grafici = [
                      this.TipiGrafici.Deformazione, 
                      this.TipiGrafici.Temperatura, 
                      this.TipiGrafici.Piezometro, 
                      this.TipiGrafici.DeformazioneO, 
                      this.TipiGrafici.TemperaturaO, 
                      this.TipiGrafici.DeformazioneOAll,
                      this.TipiGrafici.ProfiloLong,
                      this.TipiGrafici.ProfiloLongAll
                    ]
      return !Grafici.includes(this.TipoGrafico)
    },

    GetCoordsTopDataLabel(y)
    {
      let Coords = {x : 0, y : 0}
      if (this.ParentData != null) 
        Coords = this.ParentData.Refs[this.ParentData.Indice][0].getBoundingClientRect()
      return y + Coords.y
    },

    GetCoordsLeftDataLabel(x)
    {
      let Coords = {x : 0, y : 0}
      if (this.ParentData != null) 
        Coords = this.ParentData.Refs[this.ParentData.Indice][0].getBoundingClientRect()
      return x + Coords.x
    },

    OnClickMostraGrafici()
    {
      this.MenuImpostazioni = !this.MenuImpostazioni
    },

    RidimensionaCanvas()
    {
      this.$refs.Canvas.width = this.LarghezzaGrafico
      this.$refs.Canvas.height = this.AltezzaGrafico
      setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },

    GetDatiPerPDF(CumDiff = false)
    {
      let ObjParametri = {}
      ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ATTUALE
      ObjParametri.TipologiaGrafico = this.TipoGrafico
      let Data    = this.GraficoCompilato.__GruppiPunti[0].__Data
      let Indice  = 0
      let Dati    = []
      let NomePDF = ''

      // if(CumDiff)
      // {
      //   this.GraficoCompilato.CambiaDifferenziale()
      //   this.ObjGrafico.ClearAllGroupPoint()
      //   this.GraficoCompilato.DisponiPunti()
      //   this.ObjGrafico.AxisX.ClearLabels()
      //   this.ObjGrafico.AxisY.ClearLabels()
      //   this.Adatta()
      // }

      for (let i = 0; i < this.GraficoCompilato.__GruppiPunti.length; i++)
      {
        let GruppoPunti = this.GraficoCompilato.__GruppiPunti[i]
        let CurrentData = GruppoPunti.__Data
        if (CurrentData > Data)
        {
          Data = CurrentData
          Indice = i
        }
      }

      let GruppoPunti = this.GraficoCompilato.__GruppiPunti[Indice]   
      let Dato1 = ''
      let Dato2 = ''
      let Dato3 = ''
      let Tipo = this.Differenziale ? this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_CUM',this.LinguaUtente)
      if(CumDiff)
        Tipo = !this.Differenziale ? this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DIFF',this.LinguaUtente) : this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_CUM',this.LinguaUtente)
      //let ObjUdm1 = {Tipo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente), Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'}
      let ObjUdmId = {Tipo: ' '}
      let ObjUdm1 = {Tipo: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente), Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'}
      let ObjUdm2 = {Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente), Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'}
      let ObjUdm3 = {Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente), Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'}
      let GraficoLinee = 'imgLine'
      let NomeGrafico = ''
      switch (this.TipoGrafico)
      {
        case (TIPI_GRAFICI.Polare) :
        {
          Dato1 = 'SpostEst'
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_EST',this.LinguaUtente)
          ObjUdm1.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          Dato2 = 'SpostNord'          
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_NORD',this.LinguaUtente)
          ObjUdm2.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_POLARE_NOME',this.LinguaUtente)
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_POLARE_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.SpostEst) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'SpostEst'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_EST_NOME',this.LinguaUtente)
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_EST_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.SpostNord) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'SpostNord'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_NORD_NOME',this.LinguaUtente)
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_NORD_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.SpostTot) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'SpostTotale'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_TOT_NOME',this.LinguaUtente)
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST_TOT_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.SpostAzimuth) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'Azimuth'      
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente)
          ObjUdm2.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_AZIMUT_NOME',this.LinguaUtente)
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_AZIMUT_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.Temperatura) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'Temperatura'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm2.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_TEMP_NOME',this.LinguaUtente)
          Tipo = ''
          GraficoLinee = 'imgPoint'
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_TEMP_NOME_PDF',this.LinguaUtente)
          break
        }
        case (TIPI_GRAFICI.Piezometro) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'Pressione'
          Dato3 = 'Pressione'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_PRESSIONE',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_KILOPASCAL',this.LinguaUtente) + ']'
          ObjUdm3.Tipo = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_V_LIVELLO',this.LinguaUtente)
          ObjUdm3.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_PIEZO_NOME',this.LinguaUtente)
          Tipo = ''
          GraficoLinee = this.InfoCatena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'S' ? 'imgPiezometro' : 'imgPacker'
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_PIEZO_NOME_PDF',this.LinguaUtente)
          ObjParametri.IsPiezometro = true
          ObjParametri.IsPacker = this.InfoCatena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'P'          
          break
        }
        case (TIPI_GRAFICI.Deformazione) :
        {
          Dato1 = 'Profondita'
          Dato2 = 'Deformazione'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DEF_TIPO',this.LinguaUtente)
          ObjUdm2.Udm = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DEF_NOME',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DEF_NOME_PDF',this.LinguaUtente)
          break              
        }
        case (TIPI_GRAFICI.ProfiloLong) :
        {
          Dato1 = 'Distanza'
          Dato2 = 'SpostamentoOrizz'
          Dato3 = 'Temperatura'
          ObjUdmId.Tipo = this.GetTraduzioneLabel('Generic','TKN_ID_MODULO',this.LinguaUtente);
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente);
          ObjUdm1.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          ObjUdm3.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm3.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'

          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_PROF_LONG',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_PROF_LONG_NOME_PDF',this.LinguaUtente)
          ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE
          break
        }
        case (TIPI_GRAFICI.ProfiloLongAll) :
        {
          Dato1 = 'Distanza'
          Dato2 = 'SpostamentoOrizz'
          Dato3 = 'Temperatura'
          ObjUdmId.Tipo = this.GetTraduzioneLabel('Generic','TKN_ID_MODULO',this.LinguaUtente);
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente);
          ObjUdm1.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          ObjUdm3.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm3.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'

          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_PROF_LONG_ALL',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_PROF_LONG_ALL_NOME_PDF',this.LinguaUtente)
          ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE
          break
        }
        case (TIPI_GRAFICI.DeformazioneO) :
        {
          Dato1 = 'Distanza'
          Dato2 = 'Deformazione'
          Dato3 = 'Temperatura'
          ObjUdmId.Tipo = this.GetTraduzioneLabel('Generic','TKN_ID_MODULO',this.LinguaUtente);
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente);
          ObjUdm1.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE_ESTENSIONE',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          ObjUdm3.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm3.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'

          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_EST_ORIZZ',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_EST_ORIZZ_NOME_PDF',this.LinguaUtente)
          ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE
          break
        }
        case (TIPI_GRAFICI.DeformazioneOAll) :
        {
          Dato1 = 'Distanza'
          Dato2 = 'Deformazione'
          Dato3 = 'Temperatura'
          ObjUdmId.Tipo = this.GetTraduzioneLabel('Generic','TKN_ID_MODULO',this.LinguaUtente);
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente);
          ObjUdm1.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE_ESTENSIONE',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
          ObjUdm3.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm3.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'

          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_EST_ORIZZ_ALL',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_EST_ORIZZ_ALL_NOME_PDF',this.LinguaUtente)
          ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE
          break
        }
        case (TIPI_GRAFICI.TemperaturaO) :
        {
          Dato1 = 'Distanza'
          Dato2 = 'Temperatura'
          
          ObjUdmId.Tipo = this.GetTraduzioneLabel('Generic','TKN_ID_MODULO',this.LinguaUtente);
          ObjUdm1.Tipo = this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente);
          ObjUdm1.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
          ObjUdm2.Tipo = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          ObjUdm2.Udm  = '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'

          NomeGrafico = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
          Tipo = ''
          NomePDF = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_TEMP_NOME_PDF',this.LinguaUtente)
          ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_ORIZZONTALE
          break          
        }
      }

      switch (NomeGrafico)
      {
        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_DEF_NOME',this.LinguaUtente)):
        {
          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            let Punto     = GruppoPunti.__Punti[j]     
            let ModuloInfo = this.InfoCatena.Moduli.find((element) => {return element.MODULO == Punto.Modulo})
            if (ModuloInfo.ESTENSIMETRO == 'T')
            { 
              let ObjDato   = {Dato1 : 0, Dato2 : 0}
              ObjDato.Dato1 = Punto[Dato1]
              ObjDato.Dato2 = Punto[Dato2]
              if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined)
                Dati.unshift(ObjDato)
            } 
          }
          break
        }

        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_PIEZO_NOME',this.LinguaUtente)):
        {
          Dati                         = [];
          let MaxAbbinati               = this.InfoCatena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'S' ? 1 : 1;
          let GruppoPuntiPiezoVisibili = []

          // for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          // {
          //   let Punto     = GruppoPunti.__Punti[j]
          //   let ModuloInfo = this.InfoCatena.Moduli.find((element) => {return element.MODULO == Punto.Modulo})
          //   if (ModuloInfo.PIEZOMETRO == 'T')
          //   {
          //     let ObjDato   = {Dato1 : 0, Dato2 : 0} 
          //     ObjDato.Dato1 = Punto[Dato1]
          //     ObjDato.Dato2 = ((ModuloInfo.PROFONDITA_CODA * 10 - Punto[Dato2]) / 1000).toFixed(2)
          //     if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined)
          //       Dati.unshift(ObjDato)
          //   }
          // }
          
          // for (let i = 0; i < this.GraficoCompilato.__GruppiPunti.length; i++)

          for (let i = 0; i < this.GraficoCompilato.__GruppiPunti.length; i++)
          {
            let GruppoPunti = this.GraficoCompilato.__GruppiPunti[i]
            if(GruppoPunti.Visibile)
            {
              GruppoPuntiPiezoVisibili.push(GruppoPunti)
            }
          }
          
          for (let i = 0; i < MaxAbbinati; i++)
          {
            if(GruppoPuntiPiezoVisibili[i] != undefined)
            {
              let PuntiVisibili = GruppoPuntiPiezoVisibili[i].__Punti
              for(let j = 0; j < PuntiVisibili.length; j++)
              {
                let ModuloInfo = this.InfoCatena.Moduli.find((element) => {return element.MODULO == PuntiVisibili[j].Modulo})
                if (ModuloInfo.PIEZOMETRO == 'T')
                {
                  let ObjDato   = {Dato1 : 0, Dato2 : 0, Dato3 : 0} 
                  
                  ObjDato.Dato1 = PuntiVisibili[j][Dato1] != undefined ? PuntiVisibili[j][Dato1] : PuntiVisibili[j].ProfonditaPiezo
                  ObjDato.Dato2 = ((PuntiVisibili[j][Dato2] / 1000) * 9.8064).toFixed(2) 
                  let LivelloDato3 = ((ModuloInfo.PROFONDITA_CODA * 10 - PuntiVisibili[j][Dato3]) / 1000).toFixed(2)
                  ObjDato.Dato3 = LivelloDato3 * -1

                  if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined && ObjDato.Dato3 != undefined)
                    Dati.unshift(ObjDato)
                }
              }
            }
          }

          break
        }

        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_PROF_LONG',this.LinguaUtente)):
        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_PROF_LONG_ALL',this.LinguaUtente)):
        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_EST_ORIZZ',this.LinguaUtente)):
        case (this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAPH_EST_ORIZZ_ALL',this.LinguaUtente)):
        {
          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            let Punto     = GruppoPunti.__Punti[j]
            let ObjDato   = {DatoId : 0, Dato1 : 0, Dato2 : 0, Dato3 : 0}
            ObjDato.DatoId = Punto.Modulo
            ObjDato.Dato1 = Punto[Dato1]
            ObjDato.Dato2 = Punto[Dato2]
            ObjDato.Dato3 = Punto[Dato3]
            
            if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined && ObjDato.Dato3 != undefined)
              Dati.unshift(ObjDato) 
          } 
          break
        }

        default:
        {
          for (let j = 0; j < GruppoPunti.__Punti.length; j++)
          {
            let Punto     = GruppoPunti.__Punti[j]
            let ObjDato   = {DatoId : 0, Dato1 : 0, Dato2 : 0} 
            let PuntoInterpolato = GruppoPunti.__PuntiInterpolati != null ? GruppoPunti.__PuntiInterpolati.find((Elemento) => Elemento.insertBeforeIndex === j) : null
            
            ObjDato.DatoId = Punto.Modulo
            if (PuntoInterpolato != null)
            {
              ObjDato.Dato1 = PuntoInterpolato[Dato1]
              ObjDato.Dato2 = PuntoInterpolato[Dato2]
            }
            else
            {
              ObjDato.Dato1 = Punto[Dato1]
              ObjDato.Dato2 = Punto[Dato2]
            }
            
            if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined)
              Dati.unshift(ObjDato) 
          } 
          break
        } 
      }
 
      // if (NomeGrafico != 'Deformazioni')
      // {
      //   for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      //   {
      //     let Punto     = GruppoPunti.__Punti[j]
      //     let ObjDato   = {Dato1 : 0, Dato2 : 0} 
      //     ObjDato.Dato1 = Punto[Dato1]
      //     ObjDato.Dato2 = Punto[Dato2]
      //     if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined)
      //        Dati.unshift(ObjDato) 
      //   }
      // }
      // else
      // {
      //   for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      //   {
      //     let Punto     = GruppoPunti.__Punti[j]     
      //     let ModuloInfo = this.InfoCatena.Moduli.find((element) => {return element.MODULO == Punto.Modulo})
      //     if (ModuloInfo.ESTENSIMETRO == 'T')
      //     { 
      //       let ObjDato   = {Dato1 : 0, Dato2 : 0}
      //       ObjDato.Dato1 = Punto[Dato1]
      //       ObjDato.Dato2 = Punto[Dato2]
      //       if(ObjDato.Dato1 != undefined && ObjDato.Dato2 != undefined)
      //          Dati.unshift(ObjDato)
      //     } 
      //   }
      // }
      ObjParametri.Data = Data
      ObjParametri.DatiAcquisiti = Dati      
      ObjParametri.Titolo = this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + ' ' + this.InfoCatena.DatiCatena.DESCRIZIONE + ': ' + NomeGrafico + (Tipo != '' ? ' - ' + Tipo : '')
      ObjParametri.Intestazione  = {
                                      Cliente       : '',
                                      Sito          : '',
                                      Progetto      : '',
                                      Monitoraggio  : '',
                                      Installazione : '',
                                      Calibrazione  : '',
                                      IdReport      : this.GetTraduzioneLabel('Generic','TKN_REPORT',this.LinguaUtente)
                                    }
      ObjParametri.DatiGrafici = this.ObjGrafico
      ObjParametri.DatiGrafici.GraficoLinee = GraficoLinee
      ObjParametri.GraficoLinee = GraficoLinee
      ObjParametri.ObjUdmId = ObjUdmId
      ObjParametri.ObjUdmA  = ObjUdm1
      ObjParametri.ObjUdmB  = ObjUdm2
      ObjParametri.ObjUdmC  = ObjUdm3
      ObjParametri.NomePDF  = NomePDF
      ObjParametri.DataAllineamento = ''
      if(this.InfoCatena.DatiCatena.DataCampione != undefined)
        ObjParametri.DescrizioneDatiRiferiti = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_DATI_RIFERITI',this.LinguaUtente) + ': ' + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.DataCampione))
      else ObjParametri.DescrizioneDatiRiferiti = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_DATI_RIFERITI',this.LinguaUtente) + ': ' + ''
      ObjParametri.DatiPerRiepilogo = GruppoPunti
      if (this.InfoCatena.DatiCatena.Allineamento != null && this.InfoCatena.DatiCatena.Allineamento.Data != null && !(this.TipoGrafico == TIPI_GRAFICI.ProfiloLong || this.TipoGrafico == TIPI_GRAFICI.DeformazioneO))
      {
        ObjParametri.DataAllineamento = TZDateFunct.FormatDateTime('dd Mi yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Allineamento.Data))
      }

      for (let i = 0; i < this.InfoCatena.LsInfoCatena.length; i++)
      {
        let Voce = this.InfoCatena.LsInfoCatena[i]
        switch (Voce.Descrizione)
        {
          case ('Cliente'):
          {
            ObjParametri.Intestazione.Cliente = Voce.Valore
            break
          }
          case ('Sito'):
          {
            ObjParametri.Intestazione.Sito = Voce.Valore
            break
          }
          case ('Progetto'):
          {
            ObjParametri.Intestazione.Progetto = Voce.Valore
            break
          }
          case ('Intervallo monitoraggio'):
          {
            ObjParametri.Intestazione.Monitoraggio = Voce.Valore
            break
          }
          case ('Data installazione'):
          {
            ObjParametri.Intestazione.Installazione = Voce.Valore + " "
            break
          }
          case ('Ora installazione'):
          {
            ObjParametri.Intestazione.Installazione += Voce.Valore + " "
            break
          }

          case ('Data calibrazione'):
          {
            ObjParametri.Intestazione.Calibrazione = Voce.Valore + " "
            break
          }
          case ('Ora calibrazione'):
          {
            ObjParametri.Intestazione.Calibrazione += Voce.Valore + " "
            break
          }
        }
      }
      return ObjParametri      
    },

    OnClickHiddenPiezometri()
    {
      this.HiddenData = true
      if(!this.HiddenPiezometri)
      {
        for(let i = 0; i < this.InfoCatena.DatiCatena.Piezometro.length; i++)
          this.InfoCatena.DatiCatena.Piezometro[i].NASCONDI_PIEZO_INFO = false
        this.LabelGiaPresente = true
        this.Adatta()
        setTimeout(() => {this.ObjGrafico.Paint()}, 1)
      }
      else
      {
        for(let i = 0; i < this.InfoCatena.DatiCatena.Piezometro.length; i++)
          this.InfoCatena.DatiCatena.Piezometro[i].NASCONDI_PIEZO_INFO = true
        this.Adatta()
        setTimeout(() => {this.ObjGrafico.Paint()}, 1)
      }
      this.HiddenPiezometri = !this.HiddenPiezometri
    },

    ApriStampaPopupPDF()
    { 
      let ObjParametri = JSON.parse(JSON.stringify(this.GetDatiPerPDF())) 
      this.CambiaDatiGrafico()
      let ObjParametriCumDiff = JSON.parse(JSON.stringify(this.GetDatiPerPDF(true))) 
      this.CambiaDatiGrafico()
      this.$emit('ApriPopupPDF', this.InfoCatena, ObjParametri, ObjParametriCumDiff, this.TipoGrafico)
    },

    CambiaDatiGrafico()
    {
      this.GraficoCompilato.CambiaDifferenziale()
      this.ObjGrafico.ClearAllGroupPoint()
      this.GraficoCompilato.DisponiPunti()
      this.ObjGrafico.AxisX.ClearLabels()
      this.ObjGrafico.AxisY.ClearLabels()
      this.Adatta()
    },

    EsportaComePDF()
    {
      // Elaborazioni per prendere data e dati acquisiti da mostrare nel memo  
      let ObjParametri = this.GetDatiPerPDF()
      let DataOdierna = new Date()
      let NomeGrafico = this.InfoCatena.DatiCatena.DESCRIZIONE.replace('-', '') + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + ObjParametri.NomePDF + '.pdf'
      
      let VettoreGrafici = []

      let ObjGrafico  =  {
                          Catena          : this.InfoCatena.DatiCatena.CHIAVE,
                          Data            : ObjParametri.Data,
                          TipoElementoPDF : ObjParametri.TipoElementoPDF,
                          Grafici         : [ObjParametri]
                        }
                     
      VettoreGrafici.push(ObjGrafico)

      SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFAll',  { 
                                                                                // Catena  : this.InfoCatena.DatiCatena.CHIAVE,
                                                                                ChiaveSito : this.InfoCatena.DatiCatena.CHIAVE_SITO,
                                                                                VettoreDati : VettoreGrafici
                                                                                // Data    : ObjParametri.Data,
                                                                                // Grafici : [ObjParametri]
                                                                              },
                                                        function(Result)
                                                        {
                                                          // 'data:application/pdf;base64,' +                                                 
                                                          saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                        },
                                                        function(HTTPError,SubHTTPError,Response)
                                                        {
                                                          SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                        })
    },

    ApriPopupImpostazioniGrafiche()
    {
      this.ObjGraficoModifica.AxisX.MaxReale = this.InfoCatena.DatiGrafici.AXES_MAX
      this.PopupImpostazioniGrafiche         = true
    },

    AnnullaPopupImpostazioniGrafiche()
    {
      this.PopupImpostazioniGrafiche = false
      this.ObjGraficoModifica = TZGenericFunct.GetCopyOfObject(this.ObjGrafico)
    },

    AdattaDimensioniAltriGrafici()
    {
      this.$emit('AdattaAltriGrafici', this.InfoCatena.DimensioniRelative.ALTEZZA, this.InfoCatena.DimensioniRelative.LARGHEZZA)
    },

    CalculateTitleStyle()
    {
      let TitleStroke = ''
      let Top         = 20 - this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE * this.Zoom * 1.1
      let Left        = 5
      // let Top = this.GraphCenterCoords.y - (30 + this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE) * this.Zoom
      // let Left = this.GraphCenterCoords.x - 30 * this.Zoom
      // if (Top < this.GraphCenterCoords.y - (30 - this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE))
      //   Top = this.GraphCenterCoords.y - (30 - this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE)
      if (this.InfoCatena.DatiGrafici.DRAW_TITLE_STROKE)
        TitleStroke = '1px ' + this.InfoCatena.DatiGrafici.COLOR_TITLE_STROKE
      return {
               'top'                     : Top  + 'px',
               'left'                    : Left + 'px',
               'font-weight'             : 'bold',
               'font-size'               : this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE * this.Zoom + 'px',
               '-webkit-text-stroke'     : TitleStroke,
               '-webkit-text-fill-color' : this.InfoCatena.DatiGrafici.TITLE_COLOR
             }
    },

    GetXValueForLabel(Markup = null)
    {
      switch (this.TipoGrafico)
      {
        case (TIPI_GRAFICI.Polare) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.SpostEst + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.SpostEst) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.SpostEst + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.SpostNord) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.SpostNord + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.SpostTot) :
        {
          return this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_S_TOT',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.SpostTotale + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.SpostAzimuth) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_AZIMUT',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Azimuth + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.Temperatura) :
        case (TIPI_GRAFICI.TemperaturaO) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Temperatura + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.Deformazione) :
        case (TIPI_GRAFICI.DeformazioneO) :
        case (TIPI_GRAFICI.DeformazioneOAll) :   
        {
          if(this.SelectedMarkup.Hint.Deformazione != undefined)
            return this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Deformazione + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          else
            return this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Temperatura + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.Piezometro) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_PRESSIONE',this.LinguaUtente) + ': ' + Markup.Hint.PressionePiezometro + this.GetTraduzioneLabel('UdmGenerali','TKN_KILOPASCAL',this.LinguaUtente)
        }
        case (TIPI_GRAFICI.ProfiloLong) :
        case (TIPI_GRAFICI.ProfiloLongAll) :
        {
          return this.GetTraduzioneLabel('Generic','TKN_DIST',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Distanza
        }
      }
    },

    GetYValueForLabel(Markup = null)
    {
      switch (this.TipoGrafico)
      {
        case (TIPI_GRAFICI.Polare)       : return this.GetTraduzioneLabel('Generic', 'TKN_NORD_ABBR', this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.SpostNord  + this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente)
        case (TIPI_GRAFICI.SpostNord)    :
        case (TIPI_GRAFICI.SpostEst)     :
        case (TIPI_GRAFICI.SpostTot)     :
        case (TIPI_GRAFICI.SpostAzimuth) :
        case (TIPI_GRAFICI.Temperatura)  :
        case (TIPI_GRAFICI.Piezometro)   :
        case (TIPI_GRAFICI.Deformazione) :
        case (TIPI_GRAFICI.TemperaturaO) :
        case (TIPI_GRAFICI.DeformazioneO) :
        case (TIPI_GRAFICI.DeformazioneOAll) :
        {
          if(this.TipoGrafico === TIPI_GRAFICI.Piezometro && Markup.Hint.Profondita != undefined)
            return this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ': ' + Markup.Hint.Profondita + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)

          if(this.SelectedMarkup.Hint.Profondita != undefined && this.TipoGrafico !== TIPI_GRAFICI.Piezometro)
            return this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Profondita + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          break;
        }
        case (TIPI_GRAFICI.ProfiloLong) :
        case (TIPI_GRAFICI.ProfiloLongAll) :
        {
          if (this.SelectedMarkup.Hint.ProfLong != undefined)
            return this.GetTraduzioneLabel('Generic', 'TKN_SPOSTAMENTO', this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.ProfLong
          return this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ': ' + this.SelectedMarkup.Hint.Temperatura
        }
      }
    },

    GetPositionStyle()
    {
      if (this.OnDashboard)
        return {
                'top'      : this.CatenaInfo.MouseInfo.Coordinates.y + 'px',
                'left'     : this.CatenaInfo.MouseInfo.Coordinates.x + 'px',
                'width'    : this.CatenaInfo.MouseInfo.Detail.width  + 'px',
                'height'   : this.CatenaInfo.MouseInfo.Detail.height + 'px',
                'position' : 'absolute'
               }
      return {
              'position' : 'relative',
              'cursor'   : this.DragMode ? 'grab' : 'auto'
             }
    },

    ConfermaPopupImpostazioniGrafiche()
    {
      let Self = this
      let ObjQuery = {Operazioni : []}
      let ObjCatena = {Query : 'UpdateGrafica', Parametri: {}}
      ObjCatena.Parametri = {
                              CHIAVE                      : this.InfoCatena.DatiCatena.CHIAVE,
                              GRAPH_TITLE_COLOR           : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.TitleColor),
                              GRAPH_TITLE_FONT_SIZE       : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.TitleFontSize),
                              GRAPH_BACKGROUND            : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.Background),
                              GRAPH_COLOR                 : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.Color),
                              GRAPH_MARKUP                : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.MarkupScelto),
                              GRAPH_MARKUP_WIDTH          : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.MarkupWidth),
                              GRAPH_PEN_WIDTH             : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.PenWidth),
                              GRAPH_DRAW_TITLE_STROKE     : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.DrawTitleStroke),
                              GRAPH_COLOR_TITLE_STROKE    : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.ColorTitleStroke),
                              GRAPH_DRAW_BORDERS          : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.DrawBorders),
                              GRAPH_PLACEHOLDER_DIM       : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.PlaceholderDim),
                              GRAPH_AXES_MIN              : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.Min),
                              GRAPH_AXES_MAX              : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.MaxReale),
                              GRAPH_AXES_NOTCH_SIZE       : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.NotchDim),
                              GRAPH_AXES_COLOR            : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.AxisX.Color),
                              GRAPH_AXES_PEN_WIDTH        : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.PenWidth),
                              GRAPH_AXES_FONT_SIZE        : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.FontSize),
                              GRAPH_AXES_FONT_COLOR       : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.AxisX.FontColor),
                              GRAPH_AXES_NOTCH_FONT_SIZE  : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.NotchFontSize),
                              GRAPH_AXES_NOTCH_COLOR      : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.AxisX.NotchColor),
                              GRAPH_AXES_NOTCH_PEN_WIDTH  : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.AxisX.NotchPenWidth),
                              GRAPH_AXES_LABELS_USE_BOLD  : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.AxisX.FontWeight == "bolder"),
                              GRAPH_DRAW_LATERAL_LABELS   : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.AxisX.DrawLabels),
                              GRAPH_DRAW_NOTCH_LABELS     : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.AxisX.DrawNotchLabels),
                              GRAPH_AUTO_SCALE            : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.AutoScale),
                              PLACEHOLDER_TITLE_SIZE      : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.SizePlaceholder),
                              PLACEHOLDER_TITLE_COLOR     : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.ColorPlaceholder),
                              PLACEHOLDER_TEXT_POSITION   : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.PositionPlaceholder),
                              CFG_INCLINOMETRO            : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.CfgInclinometro),
                              CFG_SGHEMBO                 : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.CfgSghembo),
                              CFG_PIEZOMETRO              : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.CfgPiezometro),
                              CFG_ESTENSIMETRO            : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.CfgEstensimetro),
                              CFG_TEMPERATURA             : TSchedaGenerica.PrepareForRecordBoolean(this.ObjGraficoModifica.CfgTemperatura),
                              CFG_ACCELEROMETRO           : TSchedaGenerica.PrepareForRecordInteger(this.ObjGraficoModifica.CfgAccelerometro),
                              PLACEHOLDER_ALARM_COLOR     : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.ColorAlarmPh),
                              PLACEHOLDER_ALARM_EMPTY_CL  : TSchedaGenerica.PrepareForRecordString(this.ObjGraficoModifica.ColorAlarmEmpty),
                            }
      ObjQuery.Operazioni.push(ObjCatena)
      SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

      // this.ObjGrafico = TZGenericFunct.GetCopyOfObject(this.ObjGraficoModifica, this.ObjGrafico)

      // let FirstPointGroup = this.ObjGrafico.__PointGroups[0]
      // FirstPointGroup.Color = this.ObjGrafico.Color
      // this.ObjGrafico.SetMarkup(SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, this.ObjGrafico.Color, this.ObjGrafico.MarkupWidth),
      //                           SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, 'red', this.ObjGrafico.MarkupWidth),
      //                           () =>
      //                           {
      //                             setTimeout(() => {this.ObjGrafico.Paint()}, 50)
      //                           })
                                // FirstPointGroup.SetMarkup(SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, this.ObjGrafico.Color, this.ObjGrafico.MarkupWidth),
                                // SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, 'red', this.ObjGrafico.MarkupWidth),
                                // () =>
                                // {
                                //   setTimeout(() => {this.ObjGrafico.Paint()}, 50)
                                // })

      SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                        function()
                                                        {
                                                          Self.PopupImpostazioniGrafiche = false                                                   
                                                          location.reload();
                                                        },
                                                        function(HTTPError,SubHTTPError,Response)
                                                        {
                                                          SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                        },
                                                        false, {DMSEWSito: this.InfoCatena.DatiCatena.CHIAVE_SITO})
    },

    ApriDettaglioGrafico()
    {
      this.$emit('ApriDettaglio', this.TipoGrafico, this.GraficoCompilato)
    },

    ModificaImpostazioniAssi()
    {
      this.ObjAssi.X.Min       = this.ObjGrafico.AxisX.Min.toFixed(2)
      this.ObjAssi.X.Max       = this.ObjGrafico.AxisX.Max.toFixed(2)
      this.ObjAssi.X.Udm       = this.ObjGrafico.AxisX.NotchDim.toFixed(2)
      this.ObjAssi.X.LabelUdm  = this.UdmLabelX 
      this.ObjAssi.Y.Min       = this.ObjGrafico.AxisY.Min.toFixed(2)
      this.ObjAssi.Y.Max       = this.ObjGrafico.AxisY.Max.toFixed(2)
      this.ObjAssi.Y.Udm       = this.ObjGrafico.AxisY.NotchDim.toFixed(2)
      this.ObjAssi.Y.LabelUdm  = this.UdmLabelY
      this.ObjAssi.TipoGrafico = this.TipoGrafico
      this.ObjAssi.PopupAperto = true
    },

    ModificaFiltroAzimuth()
    {
      this.$emit('ApriPopupFiltroAzimuth', this.ObjGrafico)
    },

    ModificaDirezioneGrafico()
    {
      this.$emit('ApriPopupModificaDirezioneGrafico', this.ObjGrafico)
    },

    CambiaTipologiaCumulazione()
    {
      this.$emit('CambiaTipoCumulazione')
    },

    OnMouseDown(event)
    {
      if (!this.OnDashboard)
      {
        this.GraphicDetails.xStart = event.offsetX
        this.GraphicDetails.yStart = event.offsetY
        this.DragMode = true
      }
    },

    OnMouseUp()
    {
      this.GraphicDetails.xAngolo = 0
      this.GraphicDetails.yAngolo = 0
      this.DragMode = false
    },

    OnMouseScroll(event)
    {
      if (!this.OnDashboard) // && this.TipoGrafico != TIPI_GRAFICI.Piezometro)
      {
        event.preventDefault();

        let PreviousZoom = this.GraphicDetails.Zoom
        let CurrentZoom  = this.GraphicDetails.Zoom - (event.deltaY / 50000) * SystemInformation.UserInformation.SensibilitaScroll
        

        let MaxProfondita = this.InfoCatena.DatiCatena.MaxProfondita
        let MinProfondita = 0
        if(this.Ingrandito)
        {
          if(this.ObjGrafico && this.ObjGrafico.ListaPiezometri && this.ObjGrafico.ListaPiezometri.length > 0)
            MinProfondita = this.CalcolaProfonditaMassimaPiezometri(this.ObjGrafico.ListaPiezometri, this.ObjGrafico.AxisY.NotchDim)
        }
        let ZoomTop       = false
        let ZoomSuccess   = false
        
        if( this.TipoGrafico != TIPI_GRAFICI.TemperaturaO   &&
            this.TipoGrafico != TIPI_GRAFICI.ProfiloLong    &&
            this.TipoGrafico != TIPI_GRAFICI.ProfiloLongAll &&
            this.TipoGrafico != TIPI_GRAFICI.DeformazioneO  &&
            this.TipoGrafico != TIPI_GRAFICI.DeformazioneOAll 
          )
          ZoomSuccess  = this.ObjGrafico.GraphZoom(CurrentZoom, PreviousZoom, true, MinProfondita, MaxProfondita, ZoomTop, event.offsetX, event.offsetY)

        let VariazioneZoom = CurrentZoom - PreviousZoom
        if(this.ObjGrafico.PiezoFontZoom == undefined)
          this.ObjGrafico.PiezoFontZoom = 1
        this.ObjGrafico.PiezoFontZoom += this.ObjGrafico.PiezoFontZoom * VariazioneZoom
        if(this.ObjGrafico.PiezoFontZoom < 1)
          this.ObjGrafico.PiezoFontZoom = 1
        if (ZoomSuccess)          
          this.GraphicDetails.Zoom = CurrentZoom // this.GraphicDetails.Zoom -= (event.deltaY / 50000) * SystemInformation.UserInformation.SensibilitaScroll
      }
    },

    OnMouseEnter()
    {
      if (!this.OnDashboard)
        this.DisableScrolling()
    },

    OnMouseLeave()
    {
      this.EnableScrolling()      
      this.OnMouseUp()
    },

    EnableScrolling()
    {
      window.onscroll = function()
      {}
    },

    DisableScrolling()
    {
      let X = window.scrollX;
      let Y = window.scrollY;
      window.onscroll = function()
      {
        window.scrollTo(X, Y)
      }
    },
    
    AllarmiVisibili(CfgCatena,AllarmiAttivi)
    {
      for(const Allarme of AllarmiAttivi) 
      {
        if(CfgCatena[Allarme.TIPO] === true)
        {
          return true;
        }
        if(Allarme.TIPO === 'Accelerometro')
        {
          const MaxValore = Math.max(...Allarme.ListaModuli.map(Modulo => Math.abs(Modulo.VALORE)));
          if(MaxValore > Math.abs(CfgCatena.Accelerometro))
          {
            return true;
          }
        }
      }
      return false;
    },

    VaiAGraficiVerticali()
    {
      let ListaModuli = []
      
      let AllarmiPresenti = false
      let AllarmiCheck =  {
                            Inclinometro  : this.InfoCatena.DatiGrafici.CFG_INCLINOMETRO,
                            Piezometro    : this.InfoCatena.DatiGrafici.CFG_PIEZOMETRO,
                            Estensimetro  : this.InfoCatena.DatiGrafici.CFG_ESTENSIMETRO,
                            Temperatura   : this.InfoCatena.DatiGrafici.CFG_TEMPERATURA,
                            Accelerometro : this.InfoCatena.DatiGrafici.CFG_ACCELEROMETRO,
                            Sghembo       : this.InfoCatena.DatiGrafici.CFG_SGHEMBO
                          };
      AllarmiPresenti = this.AllarmiVisibili(AllarmiCheck, this.InfoCatena.TipiAllarmiAttivi)

      let URL = this.URLSchedaVerticali + 'ChiaveCatena=' + this.InfoCatena.DatiCatena.CHIAVE + '&ChiaveSito=' + this.InfoCatena.DatiCatena.CHIAVE_SITO + '&Estensimetri=' + this.InfoCatena.EstensimetroPresente + '&Accelerometri=' + this.InfoCatena.DatiCatena.NR_ACCELEROMETRI + '&Allarmi=' + AllarmiPresenti

      if ((this.InfoCatena.DatiCatena.ANEMOMETRO || this.InfoCatena.DatiCatena.PLUVIOMETRO || this.InfoCatena.DatiCatena.TERMOMETRO) && !this.InfoCatena.DatiCatena.INCLINOMETRI)
      {        
        if(this.InfoCatena.Moduli.length != 0)
        {
          for(let i = 0; i < this.InfoCatena.Moduli.length; i++)
          {
            let OggettoModulo          = {}
            OggettoModulo.Id           = this.InfoCatena.Moduli[i].MODULO
            OggettoModulo.Catena       = this.InfoCatena.Moduli[i].CATENA
            OggettoModulo.Profondita   = (this.InfoCatena.Moduli[i].PROFONDITA_CODA / 100).toFixed(2)
            OggettoModulo.Piezometro   = TSchedaGenerica.DisponiFromBoolean(this.InfoCatena.Moduli[i].PIEZOMETRO)
            OggettoModulo.Estensimetro = TSchedaGenerica.DisponiFromBoolean(this.InfoCatena.Moduli[i].ESTENSIMETRO)
            OggettoModulo.Selezionato  = false   
            OggettoModulo.MaxAdattamentoAsseYAccel = 3
            OggettoModulo.MaxAdattamentoAsseYSpost = 3
            OggettoModulo.MaxAdattamentoAsseYVel   = 3
            OggettoModulo.MinAdattamentoAsseYAccel = -3
            OggettoModulo.MinAdattamentoAsseYSpost = -3
            OggettoModulo.MinAdattamentoAsseYVel   = -3
            OggettoModulo.UdmYAccel                = 0.5
            OggettoModulo.UdmYSpost                = 0.5
            OggettoModulo.UdmYVel                  = 0.5
            ListaModuli.push(OggettoModulo)
          }
        }
        SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.InfoCatena.DatiCatena.CHIAVE_SITO, 
                                                                              this.InfoCatena.DatiCatena.CHIAVE,
                                                                              this.InfoCatena.DatiCatena.DESCRIZIONE,
                                                                              TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO,
                                                                              ListaModuli,
                                                                              TZDateFunct.ChangeDate(new Date(), 'day', -30), 
                                                                              new Date(), 
                                                                              '00:00', 
                                                                              TZDateFunct.FormatDateTime('hh:nn', new Date),
                                                                              false,
                                                                              false,
                                                                              0,
                                                                              0)
      
        SystemInformation.OggettoInfoGraficiStorici.VisualizzaPluviometro = this.InfoCatena.DatiCatena.PLUVIOMETRO
        SystemInformation.OggettoInfoGraficiStorici.VisualizzaAnemometro  = this.InfoCatena.DatiCatena.ANEMOMETRO
        SystemInformation.OggettoInfoGraficiStorici.VisualizzaTermometro  = this.InfoCatena.DatiCatena.TERMOMETRO
        SystemInformation.OggettoInfoGraficiStorici.VisualizzaSpostamento = false
        
        // if(this.Filtro.AllineamentoIncl != null)
          SystemInformation.OggettoInfoGraficiStorici.AllineamentoIncl     = null
        // if(this.Filtro.AllineamentoTemp != null)
          SystemInformation.OggettoInfoGraficiStorici.AllineamentoTemp     = null
        // if(this.Filtro.AllineamentoDef != null)
          SystemInformation.OggettoInfoGraficiStorici.AllineamentoDef      = null
        
        SystemInformation.OggettoInfoGraficiStorici.ListaFalde             = []
        
        SystemInformation.OggettoInfoGraficiStorici.ListaTuttiModuli       = ListaModuli

        SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena   = this.$route.fullPath
        localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
        localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici))
        // window.location.hash = '/appMainWindow/GraficiStorici'
        this.$router.push('/appMainWindow/GraficiStorici')
      }
      else
        window.location.hash = URL
      
        // this.$router.push(URL)
    },

    // VaiAGraficiVerticali()
    // {
    //   let Montaggio = TIPI_MONTAGGIO 
    //   let URL = ''
    //   let URLParams = 'ChiaveCatena=' + this.InfoCatena.DatiCatena.CHIAVE + '&ChiaveSito=' + this.InfoCatena.DatiCatena.CHIAVE_SITO + '&Estensimetri=' + this.InfoCatena.EstensimetroPresente
    //   switch(this.InfoCatena.DatiCatena.TIPO_MONTAGGIO)
    //   {
    //     case Montaggio.Standard               : URL = this.URLSchedaVerticali + URLParams
    //                                             break
    //     case Montaggio.MontaggioVerticale     : URL = this.URLMontaggioVerticale + URLParams
    //                                             break
    //     case Montaggio.MontaggioOrizzontale   : URL = this.URLMontaggioOrizzontale + URLParams
    //                                             break
    //     case Montaggio.SingoloInclinometro    : URL = this.URLSingoloInclinometro + URLParams
    //                                             break
    //     case Montaggio.TemperaturaVerticale   : URL = this.URLTemperaturaVerticale + URLParams
    //                                             break
    //     case Montaggio.TemperaturaOrizzontale : URL = this.URLTemperaturaOrizzontale + URLParams
    //                                             break
    //     default  : URL = this.URLSchedaVerticali + URLParams
    //                break
    //   }
    //   window.location.hash = URL
    //   // this.$router.push(URL)
    // },

    GetMousePosOncanvas(event)
    {
      let MarkupTrovato = false
      if (this.DragMode)
      {
        let dx = event.offsetX - this.GraphicDetails.xStart
        let dy = event.offsetY - this.GraphicDetails.yStart
        this.GraphicDetails.xStart = event.offsetX
        this.GraphicDetails.yStart = event.offsetY

        let MaxProfondita = this.InfoCatena.DatiCatena.MaxProfondita
        let MinProfondita = this.InfoCatena.DatiCatena.MinProfondita
        
        if( this.TipoGrafico != TIPI_GRAFICI.TemperaturaO   &&
            this.TipoGrafico != TIPI_GRAFICI.ProfiloLong    &&
            this.TipoGrafico != TIPI_GRAFICI.ProfiloLongAll &&
            this.TipoGrafico != TIPI_GRAFICI.DeformazioneO  &&
            this.TipoGrafico != TIPI_GRAFICI.DeformazioneOAll
          )
          this.ObjGrafico.GraphDrag(dx, dy, true, MinProfondita, MaxProfondita)
        
      }
      if (this.ObjGrafico.DrawMarkup)
      {
        this.ObjGrafico.AnnullaLastMarkup()
        this.SelectedMarkup = null
        let PuntiVisibili   = false
        
        if(this.ObjGrafico.__PointGroups)
        {
          PuntiVisibili = this.ObjGrafico.__PointGroups.some(Points => Points.Visible)
        }
        
        if(this.ObjGrafico.__PointGroups[0] && PuntiVisibili)
          this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)

        if (this.SelectedMarkup != null)
        {
          if (this.SelectedMarkup.Hint.Data != undefined)
          {
            let Data = new Date(this.SelectedMarkup.Hint.Data)
            this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)                
          }
          else
            this.SelectedMarkup.Hint.PrettyDate = this.GetTraduzioneLabel('Generic','TKN_DATI_MEDIATI',this.LinguaUtente)
          MarkupTrovato = true
        }
      }
      else
      {
        this.SelectedMarkup = null
        if(this.ObjGrafico.ListaPiezometri != undefined && this.ObjGrafico.ListaPiezometri.length > 0)
        {
          this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
          if (this.SelectedMarkup === null)
            this.SelectedMarkup = this.ObjGrafico.HighlightMarkupTriangle(event.offsetX, event.offsetY, this.ObjGrafico.__Margins.Top, this.ObjGrafico.__Margins.Bottom, this.$refs.Canvas.height)
          
          if (this.SelectedMarkup != null && this.SelectedMarkup.length > 0)
          {
            for(let i = 0; i < this.SelectedMarkup.length; i++)
            {
              let SingoloMarkup = this.SelectedMarkup[i]
              if (SingoloMarkup.Hint.Data != undefined)
              {
                let Data = new Date(SingoloMarkup.Hint.Data)
                SingoloMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)                
              }
              else
                SingoloMarkup.Hint.PrettyDate = this.GetTraduzioneLabel('Generic','TKN_DATI_MEDIATI',this.LinguaUtente)
              MarkupTrovato = true
            } 
          }

          // if (this.SelectedMarkup != null)
          // {
          //   if (this.SelectedMarkup.Hint.Data != undefined)
          //   {
          //     let Data = new Date(this.SelectedMarkup.Hint.Data)
          //     this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)                
          //   }
          //   else
          //     this.SelectedMarkup.Hint.PrettyDate = this.GetTraduzioneLabel('Generic','TKN_DATI_MEDIATI',this.LinguaUtente)
          //   MarkupTrovato = true
          // }
        }
        else 
        {
          if(this.TipoGrafico == this.TipiGrafici.DeformazioneO || this.TipoGrafico == this.TipiGrafici.DeformazioneOAll)
          {
            this.SelectedMarkup = this.ObjGrafico.HighlightHorizontalSegment(event.offsetX, event.offsetY)

            if(this.SelectedMarkup == null)
            {
              this.ObjGrafico.AnnullaLastMarkup()
              this.SelectedMarkup = null
              this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
              if (this.SelectedMarkup != null)
              {
                if (this.SelectedMarkup.Hint.Data != undefined)
                {
                  let Data = new Date(this.SelectedMarkup.Hint.Data)
                  this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)                
                }
                else
                  this.SelectedMarkup.Hint.PrettyDate = this.GetTraduzioneLabel('Generic','TKN_DATI_MEDIATI',this.LinguaUtente)
                MarkupTrovato = true
              }
            }
          }
          else this.SelectedMarkup = this.ObjGrafico.HighlightSegment(event.offsetX, event.offsetY)

          if (this.SelectedMarkup != null)
          {
            let Data = new Date(this.SelectedMarkup.Hint.Data)
            this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)

            if(this.TipoGrafico == this.TipiGrafici.DeformazioneO || this.TipoGrafico == this.TipiGrafici.DeformazioneOAll || this.TipoGrafico == this.TipiGrafici.Deformazione)
              this.SelectedMarkup.Hint.Inverted = false
            else this.SelectedMarkup.Hint.Inverted = true

            MarkupTrovato = true
          }
        }
      }
      if (!MarkupTrovato && this.TipoGrafico != TIPI_GRAFICI.Polare)
      {
        this.SelectedMarkup = null
        this.SelectedMarkup = this.ObjGrafico.ShowHorizontalAxisHint(event.offsetX, event.offsetY)
        if (this.SelectedMarkup != null)
          if (this.SelectedMarkup.Hint.Dept != null)
          {
            let Falda = this.GraficoCompilato.LsFalde.find((element) => {return element.Livello == this.SelectedMarkup.Hint.Dept})
            let Data = new Date(Falda.Data)
            this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)
            this.SelectedMarkup.Hint.Profondita = Falda.Livello
            this.SelectedMarkup.Hint.Modulo = Falda.Modulo
            this.SelectedMarkup.Hint.DontShowX = true
            this.ObjGrafico.HighlightMarkupByIdAndDate(Falda.Modulo, Falda.Data)
            MarkupTrovato = true
          }
      }
      if (!MarkupTrovato)
        this.SelectedMarkup = null
    },

    // CalcolaLabelY(Moduli, IsPiezo = false)
    // {
    //   let Misura = 0;
      
    //   if(Moduli != undefined)
    //   {
    //     if(IsPiezo)
    //     {
    //       for(let i = 0; i < Moduli.length; i++)
    //       {
    //         let Modulo = Moduli[i]
    //         if(Modulo.PIEZOMETRO == "T")
    //         {
    //           Misura = Modulo.PROFONDITA_TESTA /100
    //           break;
    //         }
    //       }
    //     }
    //     else
    //     {
    //       Misura = Moduli[0].PROFONDITA_TESTA /100
    //     }
        
    //   }
    //   return Misura
    // },

    Adatta()
    {
      // this.ObjGrafico.AxisX.LabelType = TZGraphLabelType.lblCentesimi 
      switch(this.TipoGrafico)
      {
        case TIPI_GRAFICI.Polare :
        {           
          let LabelLeftX  = ""
          let LabelRightX = ""
          let LabelLeftY  = ""
          let LabelRightY = ""
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          if (this.OnDashboard)// && !this.InfoCatena.DatiGrafici.GRAPH_AUTO_SCALE)   
          {  
            let AxesMaxCalcolato = TZMathFunct.GetMultiplo(this.InfoCatena.DatiGrafici.AXES_MAX_CALCOLATO, this.InfoCatena.DatiGrafici.NOTCH_SIZE, 'Eccesso')
            this.ObjGrafico.AxisX.Max              = AxesMaxCalcolato
            this.ObjGrafico.AxisX.Min              = AxesMaxCalcolato * -1 
            this.ObjGrafico.AxisX.NotchDim         = this.InfoCatena.DatiGrafici.NOTCH_SIZE   
            this.InfoCatena.DatiGrafici.Polare.Max = AxesMaxCalcolato
            this.InfoCatena.DatiGrafici.Polare.Min = AxesMaxCalcolato * -1 
            this.InfoCatena.DatiGrafici.Polare.Udm = this.InfoCatena.DatiGrafici.NOTCH_SIZE   
          }
          // else if(this.Ingrandito)
          // {
          //   this.ObjGrafico.AxisX.Max              = this.InfoCatena.DatiGrafici.AXES_MAX
          //   this.ObjGrafico.AxisX.Min              = this.InfoCatena.DatiGrafici.AXES_MIN
          //   this.ObjGrafico.AxisX.NotchDim         = this.InfoCatena.DatiGrafici.NOTCH_SIZE   
          //   this.InfoCatena.DatiGrafici.Polare.Max = this.InfoCatena.DatiGrafici.AXES_MAX
          //   this.InfoCatena.DatiGrafici.Polare.Min = this.InfoCatena.DatiGrafici.AXES_MIN 
          //   this.InfoCatena.DatiGrafici.Polare.Udm = this.InfoCatena.DatiGrafici.NOTCH_SIZE
          // }
          else
          {
            let ValoreXMax = TZMathFunct.GetMultiplo(this.InfoCatena.DatiGrafici.Polare.Max, this.InfoCatena.DatiGrafici.Polare.Udm, 'Eccesso')
            this.InfoCatena.DatiGrafici.Polare.Max = ValoreXMax
            this.InfoCatena.DatiGrafici.Polare.Min = ValoreXMax * -1
            this.ObjGrafico.AxisX.Max      = this.InfoCatena.DatiGrafici.Polare.Max
            this.ObjGrafico.AxisX.Min      = this.InfoCatena.DatiGrafici.Polare.Min
            this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
          }
          if(this.OnDashboard)
          {
            LabelLeftX = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente) + ' [' + this.UdmLabelX + ']'
            LabelRightY = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente) + ' [' + this.UdmLabelY + ']'
          }
          else
          {
            LabelLeftX = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente) + ' [' + this.UdmLabelX + ']'
            LabelLeftY = this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_SPOST',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente) + ' [' + this.UdmLabelY + ']'
          }
          this.ObjGrafico.AxisY.Max      = this.InfoCatena.DatiGrafici.Polare.Max
          this.ObjGrafico.AxisY.Min      = this.InfoCatena.DatiGrafici.Polare.Min
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
          this.ObjGrafico.AxisX.AddLabel(LabelLeftX, LabelRightX)
          this.ObjGrafico.AxisY.AddLabel(LabelLeftY, LabelRightY)
          this.GraficoCompilato.CompilaGraficoPolare()
          break
        }
        case TIPI_GRAFICI.SpostEst :
        {
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente))
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero      
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Direzione.MinY
          //this.ObjGrafico.AxisY.Min = this.CalcolaLabelY(this.InfoCatena.Moduli)
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmY
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Direzione.MaxX
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Direzione.MinX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmX
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.CompilaGraficoSpostEst()
          break
        }
        case TIPI_GRAFICI.SpostNord :
        {
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente))
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero   
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Direzione.MinY
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmY
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Direzione.MaxX
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Direzione.MinX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmX
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.CompilaGraficoSpostNord()
          break
        }
        case TIPI_GRAFICI.SpostTot :
        {
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Totale.MinY
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Totale.UdmY
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Totale.MinX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Totale.UdmX
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.GraficoCompilato.MaxX = this.InfoCatena.DatiGrafici.Totale.MaxX
          this.GraficoCompilato.CompilaGraficoSpostTot()
          this.ObjGrafico.AxisX.Max = this.GraficoCompilato.MaxX
          this.ObjGrafico.ShowLastPoint = false
          if(this.DirezioneGraficoTotale !== null && this.DirezioneGraficoTotale !== '')
          {
            this.ObjGrafico.AxisX.Max = this.GraficoCompilato.MaxX / 2 
            this.ObjGrafico.AxisX.Min = this.GraficoCompilato.MaxX / -2 
          }
          break
        }
        case TIPI_GRAFICI.SpostAzimuth :
        {
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Azimuth.MinX
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Azimuth.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Azimuth.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Azimuth.MinY
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Azimuth.UdmY
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.CompilaGraficoSpostAzimuth()
          break
        }
        case TIPI_GRAFICI.Temperatura :
        {
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Temperatura.MinX
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Temperatura.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Temperatura.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Temperatura.MinY
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Temperatura.UdmY
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.AllineaTemperatura = this.AllineaTemperatura
          this.GraficoCompilato.CompilaGraficoTemperatura()
          break
        }
        case TIPI_GRAFICI.Piezometro :
        {
          this.UdmLabelX = ''
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          if(!this.ObjGrafico.AxisY.LabelPresente)
            this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          if(!this.HiddenData)
            this.ObjGrafico.AxisX.AddLabel(this.UdmLabelX)
          this.ObjGrafico.AxisY.LabelPresente = true
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenStyle = []
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenStyle = []
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Pressione.MinX
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Pressione.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Pressione.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Pressione.MinY
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Pressione.UdmY
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.ObjGrafico.UltimaData      = this.UltimaData
          this.GraficoCompilato.DisponiPuntiPiezometro()
          if(this.Ingrandito)
          {
            this.ObjGrafico.UltimaData          = this.UltimaData
            this.ObjGrafico.Ingrandito          = this.Ingrandito

            if(this.ObjGrafico.ListaPiezometri && this.ObjGrafico.ListaPiezometri.length > 0)
            {
              this.ResetVisibilitaPiezometri(this.ObjGrafico.ListaPiezometri)
              this.ObjGrafico.AxisY.Max = this.CalcolaProfonditaMassimaPiezometri(this.ObjGrafico.ListaPiezometri, this.ObjGrafico.AxisY.NotchDim) 

              if(this.ObjGrafico.AxisY.Max > 0)
                this.ObjGrafico.AxisY.Max = 0
            }
          }

          break
        }
        case TIPI_GRAFICI.Deformazione :
        {     
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          
          this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Deformazione.MinX < -1 ? this.InfoCatena.DatiGrafici.Deformazione.MinX : (this.InfoCatena.DatiGrafici.Deformazione.MinX < 0 ? -1 : 0)
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Deformazione.MaxX > 1 ? this.InfoCatena.DatiGrafici.Deformazione.MaxX : 1
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Deformazione.UdmX > 0.2 ? this.InfoCatena.DatiGrafici.Deformazione.UdmX : 0.2
          
          let ValoreXMax = TZMathFunct.GetMultiplo(this.ObjGrafico.AxisX.Max, this.ObjGrafico.AxisX.NotchDim, 'Eccesso')
          this.ObjGrafico.AxisX.Max      = ValoreXMax

          //this.ObjGrafico.AxisX.LabelType  = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisX.NotchDim))
          this.ObjGrafico.AxisX.LabelType  = SystemInformation.ConvertDigitToLabelType(2)

          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Deformazione.MinY
          // this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Deformazione.MaxY
          this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Deformazione.UdmY
          this.ObjGrafico.AxisY.Inverted = true
          this.ObjGrafico.ShowFirstMarkup = false
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.CompilaGraficoDeformazione()
          break
        }
        case TIPI_GRAFICI.TemperaturaO :
        {
          // NON ALLINEARE MAI
          // GRAFICO ORIZZONTALE
          this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel('', this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          this.ObjGrafico.AxisX.Min = 0
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Temperatura.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Temperatura.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Temperatura.MinY
          
          this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Temperatura.MaxY
          // this.ObjGrafico.AxisY.Max = 0
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Temperatura.UdmY
          this.ObjGrafico.AxisY.Inverted = false
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.GraficoCompilato.CompilaGraficoOrizzontaleTemperatura()
          break
        }
        case TIPI_GRAFICI.ProfiloLong :
        {
          // NON ALLINEARE MAI
          // GRAFICO ORIZZONTALE
          this.UdmLabelX    = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.UdmLabelY    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelAltY = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          let AsseTemperatura = this.ObjGrafico.GetOtherAxis(1)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel('', this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          if(AsseTemperatura.Labels.length == 0)
            AsseTemperatura.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelAltY + ']', '', COLORE_GRAFICI_VERTICALI.Griglia)
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandardFromZero
          AsseTemperatura.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          AsseTemperatura.NotchPenStyle = []
          AsseTemperatura.NotchPenWidth = 1
          this.ObjGrafico.AxisX.Min = 0
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.MinY
          this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.MaxY
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.UdmY
          this.ObjGrafico.AxisY.Inverted = false
          AsseTemperatura.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.MinAltY
          AsseTemperatura.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.MaxAltY
          AsseTemperatura.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLong.UdmAltY
          AsseTemperatura.Inverted = false
          AsseTemperatura.FontSize      = 13;
          AsseTemperatura.LabelType     = TZGraphLabelType.lblInteger
          AsseTemperatura.NotchFontSize = 13
          AsseTemperatura.FontColor = COLORE_GRAFICI_VERTICALI.Griglia
          AsseTemperatura.LabelsStrokeColor = '#ff0000'
          this.ObjGrafico.ShowLastPoint = false
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.GraficoCompilato.CompilaGraficoOrizzontaleProfiloLong()
          break
        }
        case TIPI_GRAFICI.ProfiloLongAll :
        {
          // GRAFICO ORIZZONTALE
          this.UdmLabelX    = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)
          this.UdmLabelY    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelAltY = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          // Dovrebbe essere possibile settare l'asse della temperatura
          let AsseTemperatura = this.ObjGrafico.GetOtherAxis(1)
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisY.AddLabel('', this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          if(AsseTemperatura.Labels.length == 0)
            AsseTemperatura.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelAltY + ']', '', COLORE_GRAFICI_VERTICALI.Griglia)
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.LabelType = TZGraphLabelType.lblDecimi
          AsseTemperatura.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          AsseTemperatura.NotchPenStyle = []
          AsseTemperatura.NotchPenWidth = 1

          this.ObjGrafico.AxisX.Min = 0
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.MinY
          this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.MaxY
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.UdmY
          this.ObjGrafico.AxisY.Inverted = false
          AsseTemperatura.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.MinAltY
          AsseTemperatura.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.MaxAltY
          AsseTemperatura.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.ProfLongA.UdmAltY
          AsseTemperatura.Inverted = false
          AsseTemperatura.FontSize      = 13;
          AsseTemperatura.LabelType     = TZGraphLabelType.lblInteger
          AsseTemperatura.NotchFontSize = 13
          AsseTemperatura.FontColor = COLORE_GRAFICI_VERTICALI.Griglia
          AsseTemperatura.LabelsStrokeColor = '#ff0000'
          this.ObjGrafico.ShowLastPoint = false
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          this.ObjGrafico.ShowFirstMarkup = true
          this.GraficoCompilato.AllineaTemperatura = this.AllineaTemperatura
          this.GraficoCompilato.CompilaGraficoOrizzontaleProfLongAllineato()
          break
        }
        case TIPI_GRAFICI.DeformazioneO :
        {
          // NON ALLINEARE MAI
          // GRAFICO ORIZZONTALE
          this.UdmLabelX    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelAltY = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          let AsseTemperatura = this.ObjGrafico.GetOtherAxis(1)
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_ESTENSIONE',this.LinguaUtente), this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE',this.LinguaUtente))
          this.ObjGrafico.AxisY.AddLabel('', this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE_ESTENSIONE',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          if(AsseTemperatura.Labels.length == 0)
            AsseTemperatura.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelAltY + ']', '', COLORE_GRAFICI_VERTICALI.Griglia)
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandardFromZero
          AsseTemperatura.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          AsseTemperatura.NotchPenStyle       = []
          AsseTemperatura.NotchPenWidth       = 1

          this.ObjGrafico.AxisX.Min       = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MinX
          this.ObjGrafico.AxisX.Max       = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MaxX
          this.ObjGrafico.AxisX.NotchDim  = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.UdmX
          this.ObjGrafico.AxisY.Min       = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MinY
          this.ObjGrafico.AxisY.Max       = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MaxY
          this.ObjGrafico.AxisY.NotchDim  = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.UdmY
          this.ObjGrafico.AxisY.Inverted  = false
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          AsseTemperatura.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MinAltY
          AsseTemperatura.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.MaxAltY
          AsseTemperatura.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.Deformazione.UdmAltY
          AsseTemperatura.Inverted = false
          AsseTemperatura.FontSize      = 13;
          AsseTemperatura.LabelType     = TZGraphLabelType.lblInteger
          AsseTemperatura.NotchFontSize = 13
          AsseTemperatura.FontColor = COLORE_GRAFICI_VERTICALI.Griglia
          AsseTemperatura.LabelsStrokeColor = '#ff0000'
          this.GraficoCompilato.CompilaGraficoOrizzontaleDeformazione()
          break
        }        
        case TIPI_GRAFICI.DeformazioneOAll :
        {
          // GRAFICO ORIZZONTALE
          this.UdmLabelX    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelY    = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
          this.UdmLabelAltY = this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente)
          let AsseTemperatura = this.ObjGrafico.GetOtherAxis(1)
          this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_ESTENSIONE',this.LinguaUtente), this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE',this.LinguaUtente))
          this.ObjGrafico.AxisY.AddLabel('', this.GetTraduzioneLabel('Generic','TKN_COMPRESSIONE_ESTENSIONE',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DISTANZA_BOCCA_FORO',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')
          if(AsseTemperatura.Labels.length == 0)
            AsseTemperatura.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelAltY + ']', '', COLORE_GRAFICI_VERTICALI.Griglia)
          this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandardFromZero
          this.ObjGrafico.AxisY.LabelType = TZGraphLabelType.lblDecimi
          AsseTemperatura.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisX.NotchPenWidth = 1
          this.ObjGrafico.AxisY.NotchPenWidth = 1
          AsseTemperatura.NotchPenStyle = []
          AsseTemperatura.NotchPenWidth = 1
          
          this.ObjGrafico.AxisX.Min = 0
          this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.MaxX
          this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.UdmX
          this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.MinY
          this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.MaxY
          this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.UdmY
          this.ObjGrafico.AxisY.Inverted = false
          this.ObjGrafico.ShowFirstMarkup = true
          this.ObjGrafico.ShowLastPoint = false
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          AsseTemperatura.Min = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.MinAltY
          AsseTemperatura.Max = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.MaxAltY
          AsseTemperatura.NotchDim = this.InfoCatena.DatiGrafici.DatiGraficoOrizzontale.DeformazioneOAll.UdmAltY
          AsseTemperatura.Inverted = false
          AsseTemperatura.FontSize      = 13;
          AsseTemperatura.LabelType     = TZGraphLabelType.lblInteger
          AsseTemperatura.NotchFontSize = 13
          AsseTemperatura.FontColor = COLORE_GRAFICI_VERTICALI.Griglia
          AsseTemperatura.LabelsStrokeColor = '#ff0000'
          this.GraficoCompilato.AllineaTemperatura = this.AllineaTemperatura
          this.GraficoCompilato.CompilaGraficoOrizzontaleDeformazioneAllineata()
          break
        }
      }

      let Indice = 0

      if(this.GraficoCompilato.__GruppiPunti.length > 0)
      {
        let Data = this.GraficoCompilato.__GruppiPunti[0].__Data

        for(let i = 0; i < this.GraficoCompilato.__GruppiPunti.length; i++)
        {
          let GruppoPunti = this.GraficoCompilato.__GruppiPunti[i]
          let CurrentData = GruppoPunti.__Data

          if(CurrentData > Data)
          {
            Data   = CurrentData
            Indice = i
          }
        }

        if(this.ObjDatiEsportazione != undefined)
        {
          this.ObjDatiEsportazione.Punti                  = this.GraficoCompilato.__GruppiPunti[Indice].__Punti

          this.ObjDatiEsportazione.Generale               = this.InfoCatena.DatiCatena
          this.ObjDatiEsportazione.Generale.DataCampione  = Data
          this.ObjDatiEsportazione.Generale.PROGETTO      = (this.InfoCatena.LsInfoCatena.find((Elemento) => { return Elemento.Descrizione == 'Progetto' })).Valore
          this.ObjDatiEsportazione.Generale.Differenziale = this.Differenziale
          this.ObjDatiEsportazione.Generale.CLIENTE       = (this.InfoCatena.LsInfoCatena.find((Elemento) => { return Elemento.Descrizione == 'Cliente' })).Valore
          this.ObjDatiEsportazione.Generale.SITO          = (this.InfoCatena.LsInfoCatena.find((Elemento) => { return Elemento.Descrizione == 'Sito' })).Valore
        }
      }
    },

    ResetVisibilitaPiezometri(LsPiezometri)
    {
      if(LsPiezometri.length > 0)
      {
        LsPiezometri.forEach(
                              Piezometro => {
                                              Piezometro.ScritteVisibili = true
                                            }
                            )
      }
    },

    CalcolaProfonditaMassimaPiezometri(LsPiezometri, Multiplo)
    {
      let ProfonditaMassima = LsPiezometri[0].Profondita * -1

      for(let i = 1; i < LsPiezometri.length; i++)
      {
        let Profondita = LsPiezometri[i].Profondita * -1

        if(Profondita > ProfonditaMassima)
        {
          ProfonditaMassima = Profondita
        }
      }
      ProfonditaMassima = TZMathFunct.GetMultiplo(ProfonditaMassima, Multiplo, 'Eccesso')
      
      return (ProfonditaMassima * -1)
    },

    GestisciGraficoPolare()
    {
      if(this.OnDashboard)
      {
        this.InfoCatena.DatiGrafici.Polare.Max = this.InfoCatena.DatiGrafici.AXES_MAX
        this.InfoCatena.DatiGrafici.Polare.Min = this.InfoCatena.DatiGrafici.AXES_MAX * -1
      }
      else
      {
        this.ObjGrafico.AxisX.Max      = this.InfoCatena.DatiGrafici.Polare.Max
        this.ObjGrafico.AxisX.Min      = this.InfoCatena.DatiGrafici.Polare.Min
        this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
      }

      this.ObjGrafico.AxisY.Max      = this.InfoCatena.DatiGrafici.Polare.Max
      this.ObjGrafico.AxisY.Min      = this.InfoCatena.DatiGrafici.Polare.Min
      this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
      this.UdmLabelX                 = this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente)
      this.UdmLabelY                 = this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente)
      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_SPOSTAMENTO', this.LinguaUtente) + ' [' + this.UdmLabelX + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_EST',this.LinguaUtente))
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_SPOSTAMENTO', this.LinguaUtente) + ' [' + this.UdmLabelY + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_NORD',this.LinguaUtente))
      
      this.GraficoCompilato.CompilaGraficoPolare()
    },

    GestisciGraficoSpostEst()
    {
      this.UdmLabelX                      = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_EST_ABBR',this.LinguaUtente))
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')


      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero      
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1

      this.ObjGrafico.AxisY.Max           = 0
      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Direzione.MinY

      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Direzione.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Direzione.UdmY

      this.ObjGrafico.AxisX.Max           = this.InfoCatena.DatiGrafici.Direzione.MaxX
      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Direzione.MinX
      
      this.ObjGrafico.AxisY.Inverted      = true
      
      this.ObjGrafico.ShowFirstMarkup     = true
      
      this.GraficoCompilato.CompilaGraficoSpostEst()
    },

    GestisciGraficoSpostNord()
    {
      this.UdmLabelX                      = this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente)
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + '] --> ' + this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente))
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')

      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero   
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1

      this.ObjGrafico.AxisY.Max           = 0
      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Direzione.MinY
      
      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Direzione.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Direzione.UdmY
      
      this.ObjGrafico.AxisX.Max           = this.InfoCatena.DatiGrafici.Direzione.MaxX
      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Direzione.MinX
      
      this.ObjGrafico.AxisY.Inverted      = true
      
      this.ObjGrafico.ShowFirstMarkup     = true
      
      this.GraficoCompilato.CompilaGraficoSpostNord()
    },

    GestisciGraficoSpostTot()
    {
      this.UdmLabelX                      = this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente)
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali', 'TKN_METRI',      this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_SPOSTAMENTO', this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_PROFONDITA', this.LinguaUtente) + ' [' + this.UdmLabelY + ']')


      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1

      this.ObjGrafico.AxisY.Max           = 0
      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Totale.MinY

      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Totale.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Totale.UdmY

      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Totale.MinX

      this.ObjGrafico.AxisY.Inverted      = true

      this.ObjGrafico.ShowFirstMarkup     = true

      this.GraficoCompilato.MaxX          = this.InfoCatena.DatiGrafici.Totale.MaxX
      this.GraficoCompilato.CompilaGraficoSpostTot()
      
      this.ObjGrafico.AxisX.Max           = this.GraficoCompilato.MaxX
    },

    GestisciGraficoSpostAzimuth()
    {
      this.UdmLabelX                      = this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente)
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')

      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1

      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Azimuth.MinX
      this.ObjGrafico.AxisX.Max           = this.InfoCatena.DatiGrafici.Azimuth.MaxX

      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Azimuth.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Azimuth.UdmY

      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Azimuth.MinY
      this.ObjGrafico.AxisY.Max           = 0

      this.ObjGrafico.AxisY.Inverted      = true

      this.ObjGrafico.ShowFirstMarkup     = true

      this.GraficoCompilato.CompilaGraficoSpostAzimuth()
    },

    GestisciGraficoTemperatura()
    {
      this.UdmLabelX = this.GetTraduzioneLabel('UdmGenerali', 'TKN_CENTIGRADI', this.LinguaUtente)
      this.UdmLabelY = this.GetTraduzioneLabel('UdmGenerali', 'TKN_METRI',      this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')

      this.ObjGrafico.AxisX.NotchType          = TZGraphNotchType.notStandardFromZero
      this.ObjGrafico.AxisY.NotchType          = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth      = 1
      this.ObjGrafico.AxisY.NotchPenWidth      = 1

      this.ObjGrafico.AxisX.Min                = this.InfoCatena.DatiGrafici.Temperatura.MinX
      this.ObjGrafico.AxisX.Max                = this.InfoCatena.DatiGrafici.Temperatura.MaxX

      this.ObjGrafico.AxisX.NotchDim           = this.InfoCatena.DatiGrafici.Temperatura.UdmX
      this.ObjGrafico.AxisY.NotchDim           = this.InfoCatena.DatiGrafici.Temperatura.UdmY
      
      this.ObjGrafico.AxisY.Min                = this.InfoCatena.DatiGrafici.Temperatura.MinY
      this.ObjGrafico.AxisY.Max                = 0
      
      this.ObjGrafico.AxisY.Inverted           = true
      
      this.ObjGrafico.ShowFirstMarkup          = true
      
      this.GraficoCompilato.AllineaTemperatura = this.AllineaTemperatura
      this.GraficoCompilato.CompilaGraficoTemperatura()
    },

    GestisciGraficoPiezometro()
    {
      this.UdmLabelX                      = ''
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente)

      if (!this.LabelGiaPresente)
        this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic', 'TKN_PROFONDITA', this.LinguaUtente) + ' [' + this.UdmLabelY + ']')

      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenStyle = []
      this.ObjGrafico.AxisY.NotchPenStyle = []

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1
      
      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Pressione.MinX
      this.ObjGrafico.AxisX.Max           = this.InfoCatena.DatiGrafici.Pressione.MaxX

      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Pressione.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Pressione.UdmY

      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Pressione.MinY

      this.ObjGrafico.AxisY.Max           = 0
      
      this.ObjGrafico.AxisY.Inverted      = true
      this.ObjGrafico.ShowFirstMarkup     = true

      this.GraficoCompilato.DisponiPuntiPiezometro()
    },

    GestisciGraficoDeformazione()
    {
      this.UdmLabelX                      = this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente)
      this.UdmLabelY                      = this.GetTraduzioneLabel('UdmGenerali', 'TKN_METRI', this.LinguaUtente)

      this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
      this.ObjGrafico.AxisY.AddLabel(this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' [' + this.UdmLabelY + ']')

      this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandardFromZero
      this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard

      this.ObjGrafico.AxisX.NotchPenWidth = 1
      this.ObjGrafico.AxisY.NotchPenWidth = 1

      this.ObjGrafico.AxisX.Min           = this.InfoCatena.DatiGrafici.Deformazione.MinX
      this.ObjGrafico.AxisX.Max           = this.InfoCatena.DatiGrafici.Deformazione.MaxX

      this.ObjGrafico.AxisX.NotchDim      = this.InfoCatena.DatiGrafici.Deformazione.UdmX
      this.ObjGrafico.AxisY.NotchDim      = this.InfoCatena.DatiGrafici.Deformazione.UdmY

      this.ObjGrafico.AxisY.Min           = this.InfoCatena.DatiGrafici.Deformazione.MinY
      this.ObjGrafico.AxisY.Max           = this.InfoCatena.DatiGrafici.Deformazione.MaxY

      this.ObjGrafico.AxisY.Inverted      = true
      
      this.ObjGrafico.ShowFirstMarkup     = true
      this.GraficoCompilato.CompilaGraficoDeformazione()
    }
  },

  computed:
  {
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    },

    ObjDatiEsportazione:
    {
      get()
      {
        return this.ObjEsportazione
      }
    },

    MouseOverOnCoords:
    {
      get()
      {
        return this.CatenaInfo.MouseOverOnCoords
      }
    },

    AsseYLabels:
    {
      get()
      {
        if (this.ObjGrafico != null)
        {
          if (this.ObjGrafico.AxisY != undefined)
            return this.ObjGrafico.AxisY.Labels
        }
        return []
      }
    },

    AsseXLabels:
    {
      get()
      {
        if (this.ObjGrafico != null)
        {
          if (this.ObjGrafico.AxisX != undefined)
            return this.ObjGrafico.AxisX.Labels
        }
        return []
      }
    },

    Dimensioni:
    {
      get()
      {
        return {Larghezza : this.CatenaInfo.MouseInfo.Detail.width, Altezza : this.CatenaInfo.MouseInfo.Detail.height} 
      }
    },

    ObjAssi:
    {
      get()
      {
        return this.ObjModificaAssi
      }
    },

    FiltroAzimuth:
    {
      get()
      {
        if (this.ObjGrafico != null)
        {
          if (this.ObjGrafico.FiltroAzimuth != undefined)
            return this.ObjGrafico.FiltroAzimuth
        }
        return 0
      }
    },

    DirezioneGraficoTotale:
    {
      get()
      {
        if (this.ObjGrafico != null)
        {
          if (this.ObjGrafico.DirezioneGraficoTotale != undefined)
            return this.ObjGrafico.DirezioneGraficoTotale
        }
        return null
      }
    },

    IsOrizzontale:
    {
      get()
      {
        let Orizzontali = [TIPI_GRAFICI.TemperaturaO, TIPI_GRAFICI.ProfiloLong, TIPI_GRAFICI.DeformazioneO, TIPI_GRAFICI.ProfiloLongAll, TIPI_GRAFICI.DeformazioneOAll]
        return Orizzontali.includes(this.TipoGrafico)
      }
    }
  },

  watch:
  {
    ModificaGraficiAll:
    {
      handler()
      {
        if (this.TipoGrafico == TIPI_GRAFICI.SpostNord)
        {
          this.ObjAssi.X.Min       = this.ObjGrafico.AxisX.Min.toFixed(2)
          this.ObjAssi.X.Max       = this.ObjGrafico.AxisX.Max.toFixed(2)
          this.ObjAssi.X.Udm       = this.ObjGrafico.AxisX.NotchDim.toFixed(2)
          this.ObjAssi.Y.Min       = this.ObjGrafico.AxisY.Min.toFixed(2)
          this.ObjAssi.Y.Max       = this.ObjGrafico.AxisY.Max.toFixed(2)
          this.ObjAssi.Y.Udm       = this.ObjGrafico.AxisY.NotchDim.toFixed(2)
          this.ObjAssi.PopupAperto = true          
        }
      }
    },

    LarghezzaGrafico:
    {
      handler()
      {
        this.RidimensionaCanvas()
      }
    },

    AltezzaGrafico:
    {
      handler()
      {
        this.RidimensionaCanvas()
      }
    },

    Contatore:
    {
      handler(NewValue)
      {
        if (NewValue % this.TickIntervallo == 0 && this.MostraGrafici)
        {
          this.MostraIconaAllarme = !this.MostraIconaAllarme
          // if (this.IndiceAllarmeMostrato + 1 == this.CatenaInfo.TipiAllarmiAttivi.length)
          //   this.IndiceAllarmeMostrato = 0
          // else
          //   this.IndiceAllarmeMostrato++
        }
      }
    },

    AllineaTemperatura:
    {
      handler(NewValue)
      {
        this.GraficoCompilato.AllineaTemperatura = NewValue 
        if (this.InfoCatena.DatiCatena.Allineamento != null)
        {
          this.ObjGrafico.ClearAllGroupPoint()
          // this.GraficoCompilato.CompilaGraficoTemperatura()
          // this.GraficoCompilato.DisponiPunti()
          switch (this.TipoGrafico)
          {
            case TIPI_GRAFICI.Temperatura : 
            {
              this.GraficoCompilato.CompilaGraficoTemperatura()
              break
            }
            case TIPI_GRAFICI.ProfiloLongAll :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleProfLongAllineato()
              break
            }
            case TIPI_GRAFICI.DeformazioneOAll :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleDeformazioneAllineata()
              break
            }
          }
          setTimeout(() => {this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    FiltroAzimuth:
    {
      handler()
      {
        this.ObjGrafico.ClearAllGroupPoint()
        this.ObjGrafico.ClearOtherAxes()
        this.GraficoCompilato.DisponiPunti()
        this.GraficoCompilato.CompilaGraficoSpostAzimuth()
        setTimeout(() => {this.ObjGrafico.Paint()}, 1)
      }
    },

    DirezioneGraficoTotale:
    {
      handler()
      {
        this.ObjGrafico.ClearAllGroupPoint()
        this.GraficoCompilato.DisponiPunti()
        this.ObjGrafico.AxisX.ClearLabels()
        this.ObjGrafico.AxisY.ClearLabels()
        this.Adatta()
        setTimeout(() => {this.ObjGrafico.Paint()}, 1) 
      }
    },

    Differenziale:
    {
      handler()
      {
        this.GraficoCompilato.CambiaDifferenziale()
        this.ObjGrafico.ClearAllGroupPoint()
        this.GraficoCompilato.DisponiPunti()
        this.ObjGrafico.AxisX.ClearLabels()
        this.ObjGrafico.AxisY.ClearLabels()
        this.Adatta()
        setTimeout(() => {this.ObjGrafico.Paint()}, 1) 
      }
    },

    // LarghezzaGrafico:
    // {
    //   handler()
    // },

    GraficiChange:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.FontZoom = this.Zoom
          this.ObjGrafico.ClearAllGroupPoint()
          // NON DOVREBBE SERVIRE CANCELLARE GLI ALTRI ASSI, SE LO SI FA SI ROMPONO I GRAFICI ORIZZONTALI
          // this.ObjGrafico.ClearOtherAxes()
          // if (GRAFICI_ATTUALI_TERZO_ASSE.includes(this.TipoGrafico))
          // {
          //   let AsseTemperatura = this.ObjGrafico.AddOtherAxis()
          //   AsseTemperatura.DrawNotchLabels = true
          //   AsseTemperatura.DrawLabels = true
          //   AsseTemperatura.Color = 'red'
          //   AsseTemperatura.IdForMultipleAxes = 1        
          // }
          this.GraficoCompilato.StatoAbbinati = this.StatoAbbinati != undefined ? this.StatoAbbinati : []
          this.GraficoCompilato.StatoAbbinatiPiezometri = this.StatoAbbinatiPiezometri != undefined ? this.StatoAbbinatiPiezometri : []
          this.GraficoCompilato.DisponiPunti()

          switch (this.TipoGrafico)
          {
            case (TIPI_GRAFICI.Polare) :
            {
              this.GraficoCompilato.CompilaGraficoPolare()       
              break
            }
            case (TIPI_GRAFICI.SpostEst) :
            {
              this.GraficoCompilato.CompilaGraficoSpostEst()       
              break
            }
            case (TIPI_GRAFICI.SpostNord) :
            {
              this.GraficoCompilato.CompilaGraficoSpostNord()       
              break
            }
            case (TIPI_GRAFICI.SpostTot) :
            {
              this.GraficoCompilato.CompilaGraficoSpostTot()       
              break
            }
            case (TIPI_GRAFICI.SpostAzimuth) :
            {
              this.GraficoCompilato.CompilaGraficoSpostAzimuth()       
              break
            }
            case (TIPI_GRAFICI.Temperatura) :
            {
              this.GraficoCompilato.CompilaGraficoTemperatura()       
              break
            }
            case (TIPI_GRAFICI.Piezometro) :
            {
              this.GraficoCompilato.DisponiPuntiPiezometro()
              break
            }
            case (TIPI_GRAFICI.Deformazione) :
            {
              this.GraficoCompilato.CompilaGraficoDeformazione()       
              break              
            }
            case (TIPI_GRAFICI.TemperaturaO) :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleTemperatura()
              break
            }
            case (TIPI_GRAFICI.ProfiloLong) :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleProfiloLong()
              break
            }
            case (TIPI_GRAFICI.ProfiloLongAll) :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleProfLongAllineato()
              break
            }
            case (TIPI_GRAFICI.DeformazioneO) :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleDeformazione()
              break
            }
            case (TIPI_GRAFICI.DeformazioneOAll) :
            {
              this.GraficoCompilato.CompilaGraficoOrizzontaleDeformazioneAllineata()
              break
            }
          }

          setTimeout(() => { this.ObjGrafico.Paint() }, 1)
        }
      }
    },

    GraficiAdatta:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.ClearAllGroupPoint()
          this.ObjGrafico.ClearOtherAxes()
          this.ObjGrafico.AxisX.ClearLabels()
          this.ObjGrafico.AxisY.ClearLabels()
          this.GraficoCompilato.DisponiPunti()
          this.Adatta()
          setTimeout(() => {this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    Dimensioni:
    {
      handler()
      {
        if (this.$refs.Canvas != undefined)
        {
          this.$refs.Canvas.height = this.InfoCatena.MouseInfo.Detail.height
          this.$refs.Canvas.width = this.InfoCatena.MouseInfo.Detail.width
          this.ObjGrafico.FontZoom = this.Zoom
          this.ObjGrafico.Paint()
          this.GraphCenterCoords = this.ObjGrafico.GetCenterCoordsGraph()
          this.InfoCatena.MouseInfo.Detail.CenterCoords = {x: this.GraphCenterCoords.x, y: this.GraphCenterCoords.y}
        }
      },
      deep : true
    },

    MouseOverOnCoords:
    {
      handler(NewValue)
      {
          let xStart = this.CatenaInfo.MouseInfo.Coordinates.x
          let yStart = this.CatenaInfo.MouseInfo.Coordinates.y
          if (!NewValue.IsMouseOver)
          {
            this.ObjGrafico.AnnullaLastMarkup()
            this.SelectedMarkup = null
          }
          else
          {
            this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(NewValue.x - xStart, NewValue.y - yStart)
            if (this.SelectedMarkup != null)
            {
              this.SelectedMarkup.Hint.SpostEst = Math.round(this.SelectedMarkup.Hint.SpostEst * 10) / 10
              this.SelectedMarkup.Hint.SpostNord = Math.round(this.SelectedMarkup.Hint.SpostNord * 10) / 10
              if (this.SelectedMarkup.Hint.Data != undefined)
              {
                let Data = new Date(this.SelectedMarkup.Hint.Data)
                this.SelectedMarkup.Hint.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data)                
              }
              else
                this.SelectedMarkup.Hint.Data = this.GetTraduzioneLabel('Generic','TKN_DATI_MEDIATI',this.LinguaUtente)
            }
          }
      },
      deep : true
    },

    ObjModificaAssi:
    {
      handler()
      {
        if (!this.ObjModificaAssi.PopupAperto &&
            (this.TipoGrafico == this.ObjModificaAssi.TipoGrafico || this.ObjModificaAssi.TipoGrafico == -1) &&
            this.ObjModificaAssi.ModificaEffettuata)
        {
          if (this.ObjModificaAssi.TipoGrafico == -1)
          {
            switch (this.TipoGrafico)
            {
              case (TIPI_GRAFICI.Polare) :
              { 
                let MaxMisura = Math.max(parseFloat(this.ObjAssi.X.Max), Math.abs(parseFloat(this.ObjAssi.X.Min)))
                this.ObjGrafico.AxisX.Min      = MaxMisura * -1
                this.ObjGrafico.AxisX.Max      = MaxMisura
                this.ObjGrafico.AxisX.NotchDim = parseFloat(this.ObjAssi.X.Udm)
                break
              }
              case (TIPI_GRAFICI.SpostEst) :
              case (TIPI_GRAFICI.SpostNord) :
              { 
                this.ObjGrafico.AxisX.Min      = parseFloat(this.ObjAssi.X.Min)
                this.ObjGrafico.AxisX.Max      = parseFloat(this.ObjAssi.X.Max)
                this.ObjGrafico.AxisX.NotchDim = parseFloat(this.ObjAssi.X.Udm)
                break
              }
              case (TIPI_GRAFICI.SpostTot) :
              {
                this.ObjGrafico.AxisX.Max      = parseFloat(this.ObjAssi.X.Max) * 2
                this.ObjGrafico.AxisX.NotchDim = parseFloat(this.ObjAssi.X.Udm)
                break
              }
            }
            if (this.TipoGrafico != TIPI_GRAFICI.Polare)
            {
              this.ObjGrafico.AxisY.Min      = parseFloat(this.ObjAssi.Y.Min)
              this.ObjGrafico.AxisY.Max      = parseFloat(this.ObjAssi.Y.Max)
              this.ObjGrafico.AxisY.NotchDim = parseFloat(this.ObjAssi.Y.Udm)
            }
          }
          else
          {
            this.ObjGrafico.AxisX.Min      = parseFloat(this.ObjAssi.X.Min)
            this.ObjGrafico.AxisX.Max      = parseFloat(this.ObjAssi.X.Max)
            this.ObjGrafico.AxisX.NotchDim = parseFloat(this.ObjAssi.X.Udm)
            this.ObjGrafico.AxisY.Min      = parseFloat(this.ObjAssi.Y.Min)
            this.ObjGrafico.AxisY.Max      = parseFloat(this.ObjAssi.Y.Max)
            this.ObjGrafico.AxisY.NotchDim = parseFloat(this.ObjAssi.Y.Udm)
          }

          this.ObjGrafico.AxisX.LabelType  = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisX.NotchDim))
          this.ObjGrafico.AxisY.LabelType  = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
          this.ObjGrafico.Paint() 
        }
      },
      deep : true
    },  

    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          if (!(this.TipoGrafico == this.TipiGrafici.Deformazione && !this.InfoCatena.EstensimetroPresente))    
          {
            let ObjParametri = JSON.parse(JSON.stringify(this.GetDatiPerPDF())) 
            this.CambiaDatiGrafico()
            let ObjParametriCumDiff = JSON.parse(JSON.stringify(this.GetDatiPerPDF(true))) 
            this.CambiaDatiGrafico()

            this.InfoCatena.DatiPDF.push(ObjParametri)
            // this.InfoCatena.DatiPDFCumDiff.push(ObjParametri)
            if (this.CumulativoEDifferenzialePresenti())
              this.InfoCatena.DatiPDFCumDiff.push(ObjParametriCumDiff)
          }      
        }
      }
    },
  },

  beforeMount()
  {
    this.Admin        = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore
    this.IconaAllarme = ObjIconaAllarme.IconaAllarme
    
    if (this.InfoCatena.DatiCatena.Allineamento != null && this.InfoCatena.DatiCatena.Allineamento.Data == undefined)
    {
      if (this.InfoCatena.Allarmi.length > 1)
        this.IconaAllarme = ObjIconaAllarme.IconaAllarmeAllineamento
      else
        this.IconaAllarme = ObjIconaAllarme.IconaAllineamento
    }
    this.ObjGrafico = {PlaceholderDim : 0}
  },

  mounted()
  {
    let MaxLivello = 0
    
    for (let i = 0; i < this.InfoCatena.Allarmi.length; i++)
      if (MaxLivello < this.InfoCatena.Allarmi[i].LIVELLO)
        MaxLivello = this.InfoCatena.Allarmi[i].LIVELLO

    // this.InfoCatena.DatiCatena.MaxProfondita = 0  
    // this.InfoCatena.DatiCatena.MinProfondita = this.InfoCatena.Moduli[0].PROFONDITA_TESTA / 100    
    // for (let i = 0; i < this.InfoCatena.Moduli.length; i++)
    // {
    //   if (this.InfoCatena.Moduli[i].PROFONDITA_CODA / 100 > this.InfoCatena.DatiCatena.MaxProfondita)
    //     this.InfoCatena.DatiCatena.MaxProfondita = this.InfoCatena.Moduli[i].PROFONDITA_CODA / 100
    //   if (this.InfoCatena.Moduli[i].PROFONDITA_TESTA / 100 < this.InfoCatena.DatiCatena.MinProfondita)
    //     this.InfoCatena.DatiCatena.MinProfondita = this.InfoCatena.Moduli[i].PROFONDITA_TESTA / 100
    // }
    // let Profondita = 
    this.IconaAllarme = this.IconaAllarme.replace('yellow', COLORI_ALLARME[MaxLivello])
    this.IconaAllarme = 'data:image/svg+xml;base64,' + window.btoa(this.IconaAllarme)
    
    switch(this.TipoGrafico)
    {
       case TIPI_GRAFICI.Temperatura : this.ObjGrafico = new TZGraphLine(this.$refs.Canvas);
                                       break;
       case TIPI_GRAFICI.Piezometro  : this.ObjGrafico = (this.InfoCatena.DatiCatena.TIPO_GRAFICO_PIEZOMETRO == 'S' ? new TZGraphPiezometria(this.$refs.Canvas) : new TZGraphPacker(this.$refs.Canvas));
                                       break;
       default                       : this.ObjGrafico = new TZGraphLine(this.$refs.Canvas);
                                       break;
    }

    this.ObjGrafico.FontZoom            = this.Zoom
    this.ObjGrafico.Title               = this.InfoCatena.DatiCatena.DESCRIZIONE
    this.ObjGrafico.TitleColor          = this.InfoCatena.DatiGrafici.TITLE_COLOR
    this.ObjGrafico.TitleFontSize       = this.InfoCatena.DatiGrafici.TITLE_FONT_SIZE
    this.ObjGrafico.Background          = this.InfoCatena.DatiGrafici.BACKGROUND
    this.ObjGrafico.Color               = this.InfoCatena.DatiGrafici.COLOR
    this.ObjGrafico.PenWidth            = this.InfoCatena.DatiGrafici.PEN_WIDTH
    this.ObjGrafico.DrawBorders         = this.InfoCatena.DatiGrafici.DRAW_BORDERS
    this.ObjGrafico.DrawTitleStroke     = this.InfoCatena.DatiGrafici.DRAW_TITLE_STROKE
    this.ObjGrafico.AutoScale           = this.InfoCatena.DatiGrafici.GRAPH_AUTO_SCALE
    this.ObjGrafico.PlaceholderDim      = this.InfoCatena.DatiGrafici.PLACEHOLDER_DIM
    this.ObjGrafico.SizePlaceholder     = this.InfoCatena.DatiGrafici.PLACEHOLDER_TITLE_SIZE
    this.ObjGrafico.ColorPlaceholder    = this.InfoCatena.DatiGrafici.PLACEHOLDER_TITLE_COLOR
    this.ObjGrafico.ColorTitleStroke    = this.InfoCatena.DatiGrafici.COLOR_TITLE_STROKE
    this.ObjGrafico.MarkupWidth         = this.InfoCatena.DatiGrafici.MARKUP_WIDTH
    this.ObjGrafico.PositionPlaceholder = this.InfoCatena.DatiGrafici.PLACEHOLDER_TEXT_POSITION
    this.ObjGrafico.UltimaData          = this.UltimaData
    this.ObjGrafico.CfgInclinometro     = this.InfoCatena.DatiGrafici.CFG_INCLINOMETRO
    this.ObjGrafico.CfgSghembo          = this.InfoCatena.DatiGrafici.CFG_SGHEMBO
    this.ObjGrafico.CfgPiezometro       = this.InfoCatena.DatiGrafici.CFG_PIEZOMETRO
    this.ObjGrafico.CfgEstensimetro     = this.InfoCatena.DatiGrafici.CFG_ESTENSIMETRO
    this.ObjGrafico.CfgTemperatura      = this.InfoCatena.DatiGrafici.CFG_TEMPERATURA
    this.ObjGrafico.CfgAccelerometro    = this.InfoCatena.DatiGrafici.CFG_ACCELEROMETRO
    this.ObjGrafico.ColorAlarmPh        = this.InfoCatena.DatiGrafici.PLACEHOLDER_ALARM_COLOR
    this.ObjGrafico.ColorAlarmEmpty     = this.InfoCatena.DatiGrafici.PLACEHOLDER_ALARM_EMPTY_CL

    if (!this.OnDashboard && this.TipoGrafico != TIPI_GRAFICI.Polare && this.TipoGrafico != TIPI_GRAFICI.Temperatura)
      this.ObjGrafico.LineToMinY = true

    this.ObjGrafico.FiltroAzimuth          = this.FiltroAzimuthIngrandito != undefined ? this.FiltroAzimuthIngrandito : 0

    this.ObjGrafico.DirezioneGraficoTotale = this.DirezioneGraficoTotaleIngrandito ? this.DirezioneGraficoTotaleIngrandito : null

    if (this.InfoCatena.DatiGrafici.MARKUP == '')
      this.InfoCatena.DatiGrafici.MARKUP = SystemInformation.TipiMarkup[0].Nome
    
    this.ObjGrafico.MarkupScelto = this.InfoCatena.DatiGrafici.MARKUP
    this.ObjGrafico.SetMarkup(SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, this.ObjGrafico.Color, this.ObjGrafico.MarkupWidth),
                              SystemInformation.GetBlobSVGMarkup(this.ObjGrafico.MarkupScelto, 'red', this.ObjGrafico.MarkupWidth))
    
    let AsseX = this.ObjGrafico.AxisX
    
    AsseX.Min                = this.InfoCatena.DatiGrafici.AXES_MAX_CALCOLATO * -1
    AsseX.Max                = this.InfoCatena.DatiGrafici.AXES_MAX_CALCOLATO 
    AsseX.NotchDim           = this.InfoCatena.DatiGrafici.NOTCH_SIZE
    AsseX.Color              = this.InfoCatena.DatiGrafici.AXES_COLOR
    AsseX.PenWidth           = this.InfoCatena.DatiGrafici.AXES_PEN_WIDTH
    AsseX.NotchColor         = this.InfoCatena.DatiGrafici.NOTCH_COLOR
    AsseX.NotchFontSize      = 10
    
    if (this.OnDashboard)   
      AsseX.NotchPenWidth    = this.InfoCatena.DatiGrafici.NOTCH_PEN_WIDTH
    else
      AsseX.NotchPenWidth    = 1
    
    AsseX.FontSize           = 12
    AsseX.FontColor          = this.InfoCatena.DatiGrafici.AXES_FONT_COLOR
    AsseX.DrawLabels         = this.InfoCatena.DatiGrafici.DRAW_LATERAL_LABELS
    AsseX.DrawNotchLabels    = this.InfoCatena.DatiGrafici.DRAW_NOTCH_LABELS
    AsseX.DrawLabels         = this.InfoCatena.DatiGrafici.DRAW_NOTCH_LABELS
    AsseX.LabelType          = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(AsseX.NotchDim)) 

    let AsseY                = this.ObjGrafico.AxisY

    AsseY.Min                = this.InfoCatena.DatiGrafici.AXES_MAX_CALCOLATO * -1
    AsseY.Max                = this.InfoCatena.DatiGrafici.AXES_MAX_CALCOLATO
    AsseY.NotchDim           = this.InfoCatena.DatiGrafici.NOTCH_SIZE
    AsseY.Color              = this.InfoCatena.DatiGrafici.AXES_COLOR
    AsseY.PenWidth           = this.InfoCatena.DatiGrafici.AXES_PEN_WIDTH
    AsseY.NotchColor         = this.InfoCatena.DatiGrafici.NOTCH_COLOR
    AsseY.NotchFontSize      = 10
    
    if (this.OnDashboard)
      AsseY.NotchPenWidth    = this.InfoCatena.DatiGrafici.NOTCH_PEN_WIDTH
    else
      AsseY.NotchPenWidth    = 1
    
    AsseY.FontSize           = 12
    AsseY.FontColor          = this.InfoCatena.DatiGrafici.AXES_FONT_COLOR
    AsseY.DrawLabels         = this.InfoCatena.DatiGrafici.DRAW_LATERAL_LABELS
    AsseY.DrawNotchLabels    = this.InfoCatena.DatiGrafici.DRAW_NOTCH_LABELS
    AsseY.DrawLabels         = this.InfoCatena.DatiGrafici.DRAW_NOTCH_LABELS
    AsseY.LabelType          = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(AsseY.NotchDim)) 
    // AsseY.FontWeight         = "normal"
    // AsseX.FontWeight         = "normal"
      
    if (this.OnDashboard)
    {
      AsseX.NotchFontSize = this.InfoCatena.DatiGrafici.NOTCH_FONT_SIZE
      AsseX.FontSize      = this.InfoCatena.DatiGrafici.AXES_FONT_SIZE
      AsseX.FontWeight    = this.InfoCatena.DatiGrafici.AXES_LABELS_USE_BOLD ? "bolder" : "normal"
      AsseY.NotchFontSize = this.InfoCatena.DatiGrafici.NOTCH_FONT_SIZE
      AsseY.FontSize      = this.InfoCatena.DatiGrafici.AXES_FONT_SIZE
      AsseY.FontWeight    = this.InfoCatena.DatiGrafici.AXES_LABELS_USE_BOLD ? "bolder" : "normal"
    }

    if(this.Ingrandito)
    {
      // AsseX.FontSize      = this.InfoCatena.DatiGrafici.AXES_FONT_SIZE * INCR_INGRANDITO
      //AsseY.FontSize      = this.InfoCatena.DatiGrafici.AXES_FONT_SIZE * INCR_INGRANDITO
      this.ObjGrafico.__Margins.MinTop = this.ObjGrafico.__Margins.MinTop * 1.7
    }

    if (GRAFICI_ATTUALI_TERZO_ASSE.includes(this.TipoGrafico))
    {
      let AsseTemperatura = this.ObjGrafico.AddOtherAxis()
      AsseTemperatura.DrawNotchLabels = true
      AsseTemperatura.DrawLabels = true
      AsseTemperatura.Color = 'red'
      AsseTemperatura.IdForMultipleAxes = 1        
    }

    this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, this.Differenziale, this.StatoAbbinati != undefined ? this.StatoAbbinati : [], 
                                                this.StatoAbbinatiPiezometri != undefined ? this.StatoAbbinatiPiezometri : [])
    // switch (this.TipoGrafico)
    // {
    //   case TIPI_GRAFICI.Polare :
    //   { 
    //     this.ObjGrafico.AxisX.Max      = this.InfoCatena.DatiGrafici.Polare.Max
    //     this.ObjGrafico.AxisX.Min      = this.InfoCatena.DatiGrafici.Polare.Min
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
    //     this.ObjGrafico.AxisY.Max      = this.InfoCatena.DatiGrafici.Polare.Max
    //     this.ObjGrafico.AxisY.Min      = this.InfoCatena.DatiGrafici.Polare.Min
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Polare.Udm
    //     this.UdmLabelX = 'mm'
    //     this.UdmLabelY = 'mm'
    //     this.ObjGrafico.AxisX.AddLabel('Spostamento [' + this.UdmLabelX + '] --> Est')
    //     this.ObjGrafico.AxisY.AddLabel('Spostamento [' + this.UdmLabelY + '] --> Nord')
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoPolare()        
    //     break
    //   }
    //   case TIPI_GRAFICI.SpostEst :
    //   {
    //     this.UdmLabelX = 'mm'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel('Spostamento [' + this.UdmLabelX + '] --> E')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero      
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Direzione.MaxY
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Direzione.MinY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmY
    //     this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Direzione.MaxX
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Direzione.MinX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmX
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoSpostEst()
    //     break
    //   }
    //   case TIPI_GRAFICI.SpostNord :
    //   {
    //     this.UdmLabelX = 'mm'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel('Spostamento [' + this.UdmLabelX + '] --> N')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero   
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Direzione.MaxY
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Direzione.MinY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmY
    //     this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Direzione.MaxX
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Direzione.MinX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Direzione.UdmX
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoSpostNord()
    //     break
    //   }
    //   case TIPI_GRAFICI.SpostTot :
    //   {
    //     this.UdmLabelX = 'mm'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel('Spostamento [' + this.UdmLabelX + ']')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Totale.MaxY
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Totale.MinY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Totale.UdmY
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Totale.MinX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Totale.UdmX
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoSpostTot()
    //     this.ObjGrafico.AxisX.Max = this.GraficoCompilato.MaxX
    //     break
    //   }
    //   case TIPI_GRAFICI.SpostAzimuth :
    //   {
    //     this.UdmLabelX = '°'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel('Spostamento [' + this.UdmLabelX + ']')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Azimuth.MinX
    //     this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Azimuth.MaxX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Azimuth.UdmX
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Azimuth.MinY
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Azimuth.MaxY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Azimuth.UdmY
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoSpostAzimuth()
    //     break
    //   }
    //   case TIPI_GRAFICI.Temperatura :
    //   {
    //     this.UdmLabelX = '°C'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.UdmLabelX + ']')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Temperatura.MinX
    //     this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Temperatura.MaxX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Temperatura.UdmX
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Temperatura.MinY
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Temperatura.MaxY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Temperatura.UdmY
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoTemperatura()
    //     break
    //   }
    //   case TIPI_GRAFICI.Deformazione :
    //   {
    //     this.UdmLabelX = 'mm'
    //     this.UdmLabelY = 'm'
    //     this.ObjGrafico.AxisX.AddLabel('Deformazione [' + this.UdmLabelX + ']')
    //     this.ObjGrafico.AxisY.AddLabel('Profondità [' + this.UdmLabelY + ']')
    //     this.ObjGrafico.AxisX.NotchType = TZGraphNotchType.notStandardFromZero
    //     this.ObjGrafico.AxisY.NotchType = TZGraphNotchType.notStandard
    //     this.ObjGrafico.AxisX.NotchPenStyle = []
    //     this.ObjGrafico.AxisX.NotchPenWidth = 1
    //     this.ObjGrafico.AxisY.NotchPenStyle = []
    //     this.ObjGrafico.AxisY.NotchPenWidth = 1
    //     this.ObjGrafico.AxisX.LabelType = TZGraphLabelType.lblDecimi
    //     this.ObjGrafico.AxisX.Min = this.InfoCatena.DatiGrafici.Deformazione.MinX
    //     this.ObjGrafico.AxisX.Max = this.InfoCatena.DatiGrafici.Deformazione.MaxX
    //     this.ObjGrafico.AxisX.NotchDim = this.InfoCatena.DatiGrafici.Deformazione.UdmX
    //     this.ObjGrafico.AxisY.Min = this.InfoCatena.DatiGrafici.Deformazione.MinY
    //     this.ObjGrafico.AxisY.Max = this.InfoCatena.DatiGrafici.Deformazione.MaxY
    //     this.ObjGrafico.AxisY.NotchDim = this.InfoCatena.DatiGrafici.Deformazione.UdmY
    //     this.ObjGrafico.AxisY.Inverted = true
    //     this.ObjGrafico.ShowFirstMarkup = true
    //     this.GraficoCompilato = new TGraficoAttuale(this.InfoCatena, this.ObjGrafico, false)
    //     this.GraficoCompilato.CompilaGraficoDeformazione()
    //     break
    //   }
    // }
    
    this.Adatta()

    if(this.AssiModificatiIngranditi != undefined)
    {
      this.ObjGrafico.AxisX.Max      = parseFloat(this.AssiModificatiIngranditi.X.Max)
      this.ObjGrafico.AxisX.Min      = parseFloat(this.AssiModificatiIngranditi.X.Min)
      this.ObjGrafico.AxisX.NotchDim = parseFloat(this.AssiModificatiIngranditi.X.Udm)
      this.ObjGrafico.AxisY.Max      = parseFloat(this.AssiModificatiIngranditi.Y.Max)
      this.ObjGrafico.AxisY.Min      = parseFloat(this.AssiModificatiIngranditi.Y.Min)
      this.ObjGrafico.AxisY.NotchDim = parseFloat(this.AssiModificatiIngranditi.Y.Udm)

      if(this.TipoGrafico == TIPI_GRAFICI.Polare)
      {
        this.ObjGrafico.AxisX.Min      = parseFloat(this.AssiModificatiIngranditi.X.Max * -1)
        this.ObjGrafico.AxisY.Max      = parseFloat(this.AssiModificatiIngranditi.X.Max)
        this.ObjGrafico.AxisY.Min      = parseFloat(this.ObjGrafico.AxisX.Min)
        this.ObjGrafico.AxisY.NotchDim = parseFloat(this.AssiModificatiIngranditi.X.Udm)
      }
    }    

    this.ObjGraficoModifica = TZGenericFunct.GetCopyOfObject(this.ObjGrafico)
    
    if (this.OnDashboard)
    {
      if (this.InfoCatena.DatiCatena.Spostamenti.Date.length > 0)
      {
        let DataCalibrazionePresente = this.InfoCatena.DatiCatena.DATA_CALIBRAZIONE !== ''
        
        if(this.AllineamentoSelezionato != null)
        {        
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_DATA_CAMPIONE',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Spostamenti.Date[0].Data)))          
        }
        else
        {
          // this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MSG_GRAF_DATA',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Spostamenti.Date[0].Data)))
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_DATI_DAL',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(DataCalibrazionePresente ? this.InfoCatena.DatiCatena.DATA_CALIBRAZIONE : this.InfoCatena.DatiCatena.DATA_INSTALLAZIONE)))
          this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_A_ULTIMO_CAMPIONE',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Spostamenti.Date[0].Data)))
        }
      }
      else
        this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MSG_NO_CAMP',this.LinguaUtente))
    }

    // if (this.InfoCatena.DatiCatena.Allineamento != null)
    // {
    //   if (this.OnDashboard)
    //   {
    //     if (this.InfoCatena.DatiCatena.Allineamento.Data != undefined)
    //     {
    //       let DataAllineamento = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Allineamento.Data))
    //       if (DataAllineamento >= TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', TZDateFunct.ChangeDate(this.AllineamentoSelezionato, 'minute', -1)) &&
    //           DataAllineamento <= TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn',TZDateFunct.ChangeDate(this.AllineamentoSelezionato, 'minute', 1)))
    //         this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MSG_ALL_DATA',this.LinguaUtente) + ' ' + DataAllineamento)
    //       else
    //         this.ObjGrafico.AxisX.AddLabel(this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MSG_ALL_DATA',this.LinguaUtente) + ' ' + DataAllineamento, '', 'orange')   
    //     }
    //     else
    //     {
    //       this.InfoCatena.TipiAllarmiAttivi.push({TIPO: this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MSG_ALL_NON_TROVATO',this.LinguaUtente), LIVELLO: '', ListaModuli: [{MODULO: '-', VALORE: '-'}]})
    //     }
    //   }
    // }

    if (!this.OnDashboard)
    {
      switch (this.TipoGrafico)
      {
        case TIPI_GRAFICI.Polare :
        {
          AsseX.PenStyle        = []
          AsseY.PenStyle        = []
          AsseX.Max             = TZMathFunct.GetMultiplo(AsseX.Max, AsseX.NotchDim, 'Difetto')
          AsseX.Min             = AsseX.Max * (-1)
          AsseX.DrawNotchLabels = true
          this.ObjGrafico.DrawBorders = true
          this.ObjGrafico.DeleteGraphOverboard = true
          AsseY.DrawNotchLabels = false
          AsseX.UpperLabelText  = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + '] ' + this.GetTraduzioneLabel('Generic','TKN_NORD_ABBR',this.LinguaUtente)
          
          // let AltroAsse1             = this.ObjGrafico.AddOtherAxis()
          // AltroAsse1.Color           = this.InfoCatena.DatiGrafici.AXES_COLOR
          // AltroAsse1.PenWidth        = this.InfoCatena.DatiGrafici.AXES_PEN_WIDTH
          // AltroAsse1.NotchColor      = this.InfoCatena.DatiGrafici.NOTCH_COLOR
          // AltroAsse1.NotchFontSize   = this.InfoCatena.DatiGrafici.NOTCH_FONT_SIZE
          // AltroAsse1.NotchPenWidth   = this.InfoCatena.DatiGrafici.NOTCH_PEN_WIDTH
          // AltroAsse1.DrawLabels      = false
          // AltroAsse1.DrawNotchLabels = false
          // AltroAsse1.Inclination     = 45
          // AltroAsse1.PenStyle        = [5,5]
          // let AltroAsse2             = this.ObjGrafico.AddOtherAxis()
          // AltroAsse2.Color           = this.InfoCatena.DatiGrafici.AXES_COLOR
          // AltroAsse2.PenWidth        = this.InfoCatena.DatiGrafici.AXES_PEN_WIDTH
          // AltroAsse2.NotchColor      = this.InfoCatena.DatiGrafici.NOTCH_COLOR
          // AltroAsse2.NotchFontSize   = this.InfoCatena.DatiGrafici.NOTCH_FONT_SIZE
          // AltroAsse2.NotchPenWidth   = this.InfoCatena.DatiGrafici.NOTCH_PEN_WIDTH
          // AltroAsse2.DrawLabels      = false
          // AltroAsse2.DrawNotchLabels = false
          // AltroAsse2.Inclination     = 135
          // AltroAsse2.PenStyle        = [5,5]
          this.$refs.Canvas.height = this.LarghezzaGrafico
          this.$refs.Canvas.width  = this.LarghezzaGrafico
          // this.$refs.Canvas.height = this.InfoCatena.MouseInfo.Detail.height
          // this.$refs.Canvas.width = this.InfoCatena.MouseInfo.Detail.width
          break
        }
        case TIPI_GRAFICI.SpostEst : 
        case TIPI_GRAFICI.SpostNord :
        case TIPI_GRAFICI.SpostTot :
        case TIPI_GRAFICI.SpostAzimuth :
        {
          AsseX.DrawNotchLabels       = true
          AsseY.DrawNotchLabels       = true
          this.ObjGrafico.DrawBorders = true
          AsseX.DrawLabels            = true
          AsseY.DrawLabels            = true 
          this.$refs.Canvas.width     = this.LarghezzaGrafico
          this.$refs.Canvas.height    = this.AltezzaGrafico
          break
        }
        case TIPI_GRAFICI.Temperatura :
        {
          AsseX.DrawNotchLabels       = true
          AsseY.DrawNotchLabels       = true
          this.ObjGrafico.DrawBorders = true
          AsseX.DrawLabels            = true
          AsseY.DrawLabels            = true 
          this.$refs.Canvas.width     = this.LarghezzaGrafico
          this.$refs.Canvas.height    = this.AltezzaGrafico
          break
        }
        case TIPI_GRAFICI.Piezometro :
        {
          AsseX.DrawNotchLabels       = true
          AsseY.DrawNotchLabels       = true
          this.ObjGrafico.DrawBorders = true
          this.ObjGrafico.DrawMarkup  = false
          AsseX.DrawLabels            = true
          AsseY.DrawLabels            = true 
          this.$refs.Canvas.width     = this.LarghezzaGrafico
          this.$refs.Canvas.height    = this.AltezzaGrafico
          break
        }
        case TIPI_GRAFICI.Deformazione :
        {
          AsseX.DrawNotchLabels       = true
          AsseY.DrawNotchLabels       = true
          this.ObjGrafico.DrawBorders = true
          AsseX.DrawLabels            = true
          AsseY.DrawLabels            = true 
          this.ObjGrafico.DrawMarkup  = false
          this.$refs.Canvas.width     = this.LarghezzaGrafico
          this.$refs.Canvas.height    = this.AltezzaGrafico
          this.ObjGrafico.LineToMinY = true
          break
        }
        case TIPI_GRAFICI.TemperaturaO :
        {
          AsseX.DrawNotchLabels = true
          AsseY.DrawNotchLabels = true
          this.ObjGrafico.DrawBorders = true
          AsseX.DrawLabels = true
          AsseY.DrawLabels = true 
          this.ObjGrafico.LineToMinY = false
          this.$refs.Canvas.width = this.LarghezzaGrafico
          this.$refs.Canvas.height = this.AltezzaGrafico
          break
        }
        case TIPI_GRAFICI.ProfiloLong :
        case TIPI_GRAFICI.ProfiloLongAll :
        {
          AsseX.DrawNotchLabels = true
          AsseY.DrawNotchLabels = true
          this.ObjGrafico.DrawBorders = true
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          AsseX.DrawLabels = true
          AsseY.DrawLabels = true 
          this.ObjGrafico.LineToMinY = false
          this.$refs.Canvas.width = this.LarghezzaGrafico
          this.$refs.Canvas.height = this.AltezzaGrafico
          break
        }        
        case TIPI_GRAFICI.DeformazioneO :
        case TIPI_GRAFICI.DeformazioneOAll :
        {
          AsseX.DrawNotchLabels = true
          AsseY.DrawNotchLabels = true
          this.ObjGrafico.DrawBorders = true
          this.ObjGrafico.ShowYLabelNotStandardFromZero = true
          this.ObjGrafico.DrawTaccheNelTerzoAsse = true
          AsseX.DrawLabels = true
          AsseY.DrawLabels = true 
          this.ObjGrafico.DrawMarkup = false
          this.ObjGrafico.LineToMinY = false
          this.$refs.Canvas.width = this.LarghezzaGrafico
          this.$refs.Canvas.height = this.AltezzaGrafico
          break
        }
      }
      setTimeout(() => {this.ObjGrafico.Paint()}, 1)
      this.$refs.Canvas.addEventListener('mousemove', this.GetMousePosOncanvas)
    }
    else
    {
      AsseX.DrawNotchLabels = true
      AsseY.DrawNotchLabels = false
    }
  },
  
  beforeUnmount()
  {
    this.$refs.Canvas.removeEventListener('mousemove', this.GetMousePosOncanvas)
  }
}
</script>